/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Map
#Global accordions
#Global shortcodes


/* ===========================================================
Filter & Sort
=========================================================*/
  $('#filter-sort-button').on('click',  function () {
    var obj = document.querySelector('.shopify-section--collection-template .sidebar')
    obj.classList.add('sidebar-open');
    var obj2 = document.getElementById("icon-facet-drawer-id");
    obj2.classList.add('icon-facet-drawer-open');
    var obj3 = document.querySelector('.shopify-section--collection-template .sidebar-wrap');
    obj3.classList.add('sidebar-wrap-open');
    
  });

  $('#icon-facet-drawer-id').on('click',function(){
    var obj = document.querySelector('.shopify-section--collection-template .sidebar')
    obj.classList.remove('sidebar-open');
    var obj2 = document.getElementById("icon-facet-drawer-id");
    obj2.classList.remove('icon-facet-drawer-open');
    var obj3 = document.querySelector('.shopify-section--collection-template .sidebar-wrap-open');
    obj3.classList.remove('sidebar-wrap-open');  
  });
  
/* ============= */
  $('#express-search-button').on('click',  function () {

    var expresspostcode = $(this).prev().val();
    const str = '79000,TRUE|79050,TRUE|79100,TRUE|79150,TRUE|79200,TRUE|79250,TRUE|79502,TRUE|79503,TRUE|79504,TRUE|79511,TRUE|79513,TRUE|79514,TRUE|79517,TRUE|79518,TRUE|79520,TRUE|79521,TRUE|79523,TRUE|79532,TRUE|79538,TRUE|79540,TRUE|79546,TRUE|79548,TRUE|79550,TRUE|79555,TRUE|79570,TRUE|79575,TRUE|79576,TRUE|79582,TRUE|79592,TRUE|79601,TRUE|79603,TRUE|79605,TRUE|79606,TRUE|79612,TRUE|79626,TRUE|79630,TRUE|79632,TRUE|79646,TRUE|79658,TRUE|79660,TRUE|79680,TRUE|79681,TRUE|79683,TRUE|80000,TRUE|80050,TRUE|80057,FALSE|80100,TRUE|80150,TRUE|80200,TRUE|80250,TRUE|80300,TRUE|80350,TRUE|80357,FALSE|80359,FALSE|80400,TRUE|80500,TRUE|80505,TRUE|80506,TRUE|80508,TRUE|80514,TRUE|80516,TRUE|80519,TRUE|80534,TRUE|80536,TRUE|80538,TRUE|80542,TRUE|80544,TRUE|80546,TRUE|80554,TRUE|80558,TRUE|80560,TRUE|80564,TRUE|80568,TRUE|80578,TRUE|80586,TRUE|80590,TRUE|80592,TRUE|80594,TRUE|80596,TRUE|80598,TRUE|80600,TRUE|80604,TRUE|80608,TRUE|80620,TRUE|80622,TRUE|80628,TRUE|80644,TRUE|80648,TRUE|80662,TRUE|80664,TRUE|80670,TRUE|80672,TRUE|80673,TRUE|80676,TRUE|80690,TRUE|80700,FALSE|80710,FALSE|80720,FALSE|80730,FALSE|80900,FALSE|80902,FALSE|80904,FALSE|80906,FALSE|80908,FALSE|80988,TRUE|80990,TRUE|81000,TRUE|81007,FALSE|81009,FALSE|81100,TRUE|81107,FALSE|81200,TRUE|81300,TRUE|81307,FALSE|81310,TRUE|81400,TRUE|81407,FALSE|81409,TRUE|81440,TRUE|81447,FALSE|81450,TRUE|81500,TRUE|81507,FALSE|81550,TRUE|81551,TRUE|81552,TRUE|81556,TRUE|81557,FALSE|81600,TRUE|81700,TRUE|81707,FALSE|81750,TRUE|81757,FALSE|81759,TRUE|81800,TRUE|81807,FALSE|81809,TRUE|81850,TRUE|81900,TRUE|81907,FALSE|81920,TRUE|81927,FALSE|81930,TRUE|81937,FALSE|82000,TRUE|82007,FALSE|82009,TRUE|82100,TRUE|82200,TRUE|82207,FALSE|82300,TRUE|83000,TRUE|83007,FALSE|83009,FALSE|83010,TRUE|83100,TRUE|83200,TRUE|83300,TRUE|83307,FALSE|83400,TRUE|83407,FALSE|83500,TRUE|83600,TRUE|83700,TRUE|83707,FALSE|84000,TRUE|84007,FALSE|84150,TRUE|84157,FALSE|84200,TRUE|84300,TRUE|84400,TRUE|84407,FALSE|84500,TRUE|84600,TRUE|84700,TRUE|84800,TRUE|84900,TRUE|84907,FALSE|84909,TRUE|85000,TRUE|85007,FALSE|85100,TRUE|85109,TRUE|85200,TRUE|85300,TRUE|85307,FALSE|85309,TRUE|85400,TRUE|86000,TRUE|86007,FALSE|86009,TRUE|86100,TRUE|86107,FALSE|86200,TRUE|86207,FALSE|86300,TRUE|86400,TRUE|86407,FALSE|86500,TRUE|86600,TRUE|86700,TRUE|86707,FALSE|86800,TRUE|86807,FALSE|86810,TRUE|86888,FALSE|86900,TRUE|5000,TRUE|5050,TRUE|5100,TRUE|5150,TRUE|5200,TRUE|5250,TRUE|5300,TRUE|5350,TRUE|5400,TRUE|5460,TRUE|5500,TRUE|5502,TRUE|5503,TRUE|5504,TRUE|5505,TRUE|5506,TRUE|5508,TRUE|5512,TRUE|5514,TRUE|5516,TRUE|5517,TRUE|5518,TRUE|5520,TRUE|5532,TRUE|5534,TRUE|5536,TRUE|5538,TRUE|5550,TRUE|5551,TRUE|5552,TRUE|5556,TRUE|5558,TRUE|5560,TRUE|5564,TRUE|5576,TRUE|5578,TRUE|5580,TRUE|5582,TRUE|5586,TRUE|5590,TRUE|5592,TRUE|5594,TRUE|5600,TRUE|5604,TRUE|5610,TRUE|5612,TRUE|5614,TRUE|5620,TRUE|5621,TRUE|5622,TRUE|5626,TRUE|5628,TRUE|5630,TRUE|5632,TRUE|5644,TRUE|5646,TRUE|5660,TRUE|5661,TRUE|5664,TRUE|5670,TRUE|5672,TRUE|5673,TRUE|5674,TRUE|5675,TRUE|5676,TRUE|5680,TRUE|5690,TRUE|5696,TRUE|5700,FALSE|5710,FALSE|5720,FALSE|5990,TRUE|6000,TRUE|6007,FALSE|6009,TRUE|6010,TRUE|6050,TRUE|6100,TRUE|6150,TRUE|6200,TRUE|6207,FALSE|6209,TRUE|6250,TRUE|6300,TRUE|6309,TRUE|6350,TRUE|6400,TRUE|6500,TRUE|6507,FALSE|6509,TRUE|6550,TRUE|6570,TRUE|6600,TRUE|6650,TRUE|6700,TRUE|6707,FALSE|6709,TRUE|6710,TRUE|6720,TRUE|6750,TRUE|6760,TRUE|6800,TRUE|6900,TRUE|6910,TRUE|7000,TRUE|7007,FALSE|7009,TRUE|8000,TRUE|8007,FALSE|8009,TRUE|8010,TRUE|8100,TRUE|8107,FALSE|8109,TRUE|8110,TRUE|8200,TRUE|8210,TRUE|8300,TRUE|8307,FALSE|8320,TRUE|8400,TRUE|8407,FALSE|8409,TRUE|8500,TRUE|8507,FALSE|8509,TRUE|8600,TRUE|8700,TRUE|8800,TRUE|9000,TRUE|9007,FALSE|9009,TRUE|9010,TRUE|9020,TRUE|9100,TRUE|9109,TRUE|9110,TRUE|9120,TRUE|9130,TRUE|9200,TRUE|9300,TRUE|9309,TRUE|9310,TRUE|9400,TRUE|9409,TRUE|9500,TRUE|9600,TRUE|9700,TRUE|9709,TRUE|9800,TRUE|9809,FALSE|9810,TRUE|14390,TRUE|34950,TRUE|15000,TRUE|15050,TRUE|15100,TRUE|15150,TRUE|15159,TRUE|15200,TRUE|15300,TRUE|15350,TRUE|15400,TRUE|15500,TRUE|15502,TRUE|15503,TRUE|15504,TRUE|15505,TRUE|15506,TRUE|15508,TRUE|15512,TRUE|15514,TRUE|15516,TRUE|15517,TRUE|15518,TRUE|15519,TRUE|15520,TRUE|15524,TRUE|15529,TRUE|15532,TRUE|15534,TRUE|15536,TRUE|15538,TRUE|15540,TRUE|15546,TRUE|15548,TRUE|15550,TRUE|15551,TRUE|15552,TRUE|15556,TRUE|15558,TRUE|15560,TRUE|15564,TRUE|15570,TRUE|15572,TRUE|15576,TRUE|15578,TRUE|15582,TRUE|15586,TRUE|15590,TRUE|15592,TRUE|15594,TRUE|15596,TRUE|15600,TRUE|15604,TRUE|15608,TRUE|15609,TRUE|15612,TRUE|15614,TRUE|15616,TRUE|15622,TRUE|15623,TRUE|15626,TRUE|15628,TRUE|15630,TRUE|15632,TRUE|15634,TRUE|15644,TRUE|15646,TRUE|15648,TRUE|15658,TRUE|15660,TRUE|15661,TRUE|15664,TRUE|15670,TRUE|15672,TRUE|15673,TRUE|15674,TRUE|15675,TRUE|15676,TRUE|15680,TRUE|15690,TRUE|15710,FALSE|15720,TRUE|15730,FALSE|15740,FALSE|15988,FALSE|15990,TRUE|16010,TRUE|16020,TRUE|16040,TRUE|16050,TRUE|16070,TRUE|16080,TRUE|16090,TRUE|16100,TRUE|16109,TRUE|16150,TRUE|16200,TRUE|16210,TRUE|16250,TRUE|16300,TRUE|16309,TRUE|16310,TRUE|16400,TRUE|16450,TRUE|16500,TRUE|16600,TRUE|16700,TRUE|16800,TRUE|16810,TRUE|17000,TRUE|17007,FALSE|17009,TRUE|17010,TRUE|17020,TRUE|17030,TRUE|17040,TRUE|17050,TRUE|17060,TRUE|17070,TRUE|17200,TRUE|17207,TRUE|17500,TRUE|17507,FALSE|17509,TRUE|17510,TRUE|17600,TRUE|17609,TRUE|17610,TRUE|17700,TRUE|18000,TRUE|18007,FALSE|18009,TRUE|18050,TRUE|18200,TRUE|18300,TRUE|18307,FALSE|18400,TRUE|18500,TRUE|18509,TRUE|75000,TRUE|75050,TRUE|75100,TRUE|75150,TRUE|75200,TRUE|75250,TRUE|75260,TRUE|75300,TRUE|75350,TRUE|75400,TRUE|75450,TRUE|75459,FALSE|75460,TRUE|75500,TRUE|75502,TRUE|75503,TRUE|75504,TRUE|75505,TRUE|75506,TRUE|75508,TRUE|75510,TRUE|75512,TRUE|75514,TRUE|75516,TRUE|75517,TRUE|75518,TRUE|75519,TRUE|75532,TRUE|75536,TRUE|75538,TRUE|75540,TRUE|75542,TRUE|75546,TRUE|75550,TRUE|75551,TRUE|75552,TRUE|75560,TRUE|75564,TRUE|75566,TRUE|75570,TRUE|75572,TRUE|75576,TRUE|75578,TRUE|75582,TRUE|75584,TRUE|75586,TRUE|75590,TRUE|75592,TRUE|75594,TRUE|75596,TRUE|75600,TRUE|75604,TRUE|75606,TRUE|75608,TRUE|75609,TRUE|75612,TRUE|75620,TRUE|75622,TRUE|75623,TRUE|75626,TRUE|75628,TRUE|75630,TRUE|75632,TRUE|75646,TRUE|75648,TRUE|75664,TRUE|75670,TRUE|75672,TRUE|75673,TRUE|75674,TRUE|75676,TRUE|75690,TRUE|75700,FALSE|75710,FALSE|75720,FALSE|75730,FALSE|75740,FALSE|75750,FALSE|75760,FALSE|75900,FALSE|75902,FALSE|75904,FALSE|75906,FALSE|75908,FALSE|75910,FALSE|75912,FALSE|75914,FALSE|75916,FALSE|75918,FALSE|75990,FALSE|76100,TRUE|76109,FALSE|76200,TRUE|76300,TRUE|76400,TRUE|76409,TRUE|76450,TRUE|77000,TRUE|77007,FALSE|77008,FALSE|77009,TRUE|77100,TRUE|77109,TRUE|77200,TRUE|77300,TRUE|77307,FALSE|77309,TRUE|77400,TRUE|77409,TRUE|77500,TRUE|77507,FALSE|77509,TRUE|78000,TRUE|78007,FALSE|78009,TRUE|78100,TRUE|78200,TRUE|78300,TRUE|78307,FALSE|78309,TRUE|70000,TRUE|70100,TRUE|70200,TRUE|70300,TRUE|70400,TRUE|70450,TRUE|70500,TRUE|70502,TRUE|70503,TRUE|70504,TRUE|70505,TRUE|70506,TRUE|70508,TRUE|70512,TRUE|70516,TRUE|70517,TRUE|70518,TRUE|70532,TRUE|70534,TRUE|70536,TRUE|70538,TRUE|70540,TRUE|70546,TRUE|70548,TRUE|70550,TRUE|70551,TRUE|70558,TRUE|70560,TRUE|70564,TRUE|70570,TRUE|70572,TRUE|70576,TRUE|70578,TRUE|70582,TRUE|70586,TRUE|70590,TRUE|70592,TRUE|70594,TRUE|70596,TRUE|70600,TRUE|70604,TRUE|70606,TRUE|70608,TRUE|70609,TRUE|70610,TRUE|70612,TRUE|70620,TRUE|70626,TRUE|70628,TRUE|70632,TRUE|70634,TRUE|70644,TRUE|70646,TRUE|70648,TRUE|70658,TRUE|70664,TRUE|70670,TRUE|70672,TRUE|70673,TRUE|70674,TRUE|70676,TRUE|70690,TRUE|70700,FALSE|70710,FALSE|70720,FALSE|70730,FALSE|70740,FALSE|70750,FALSE|70990,FALSE|71000,TRUE|71007,FALSE|71009,FALSE|71010,TRUE|71050,TRUE|71059,FALSE|71100,TRUE|71150,TRUE|71159,FALSE|71200,TRUE|71209,FALSE|71250,TRUE|71259,FALSE|71300,TRUE|71309,FALSE|71350,TRUE|71359,FALSE|71400,TRUE|71409,FALSE|71450,TRUE|71459,FALSE|71500,TRUE|71509,FALSE|71550,TRUE|71559,FALSE|71600,TRUE|71650,TRUE|71659,FALSE|71700,TRUE|71707,FALSE|71709,FALSE|71750,TRUE|71759,FALSE|71760,TRUE|71770,TRUE|71800,TRUE|71807,FALSE|71809,FALSE|71900,TRUE|71907,FALSE|71909,FALSE|71950,TRUE|71960,TRUE|72000,TRUE|72007,FALSE|72009,FALSE|72100,TRUE|72107,FALSE|72109,FALSE|72120,TRUE|72127,FALSE|72129,FALSE|72200,TRUE|72207,FALSE|72209,FALSE|72300,TRUE|72307,FALSE|72309,FALSE|72400,TRUE|72409,FALSE|72500,TRUE|72507,FALSE|72509,FALSE|73000,TRUE|73007,FALSE|73009,FALSE|73010,TRUE|73100,TRUE|73109,FALSE|73200,TRUE|73207,FALSE|73209,FALSE|73300,TRUE|73309,FALSE|73400,TRUE|73409,FALSE|73430,TRUE|73440,TRUE|73450,TRUE|73470,TRUE|73480,TRUE|73500,TRUE|73507,FALSE|73509,FALSE|25000,TRUE|25050,TRUE|25100,TRUE|25150,TRUE|25200,TRUE|25250,TRUE|25300,TRUE|25350,TRUE|25500,TRUE|25502,TRUE|25503,TRUE|25504,TRUE|25505,TRUE|25506,TRUE|25508,TRUE|25509,TRUE|25512,TRUE|25514,TRUE|25516,TRUE|25517,TRUE|25518,TRUE|25520,TRUE|25524,TRUE|25529,TRUE|25532,TRUE|25534,TRUE|25536,TRUE|25538,TRUE|25540,TRUE|25546,TRUE|25548,TRUE|25550,TRUE|25551,TRUE|25552,TRUE|25556,TRUE|25558,TRUE|25560,TRUE|25564,TRUE|25570,TRUE|25576,TRUE|25578,TRUE|25582,TRUE|25584,TRUE|25586,TRUE|25590,TRUE|25592,TRUE|25594,TRUE|25596,TRUE|25598,TRUE|25600,TRUE|25604,TRUE|25606,TRUE|25608,TRUE|25609,TRUE|25612,TRUE|25614,TRUE|25620,TRUE|25622,TRUE|25626,TRUE|25628,TRUE|25630,TRUE|25632,TRUE|25644,TRUE|25646,TRUE|25648,TRUE|25656,TRUE|25660,TRUE|25661,TRUE|25662,TRUE|25670,TRUE|25672,TRUE|25673,TRUE|25674,TRUE|25676,TRUE|25690,TRUE|25700,TRUE|25709,FALSE|25710,TRUE|25720,TRUE|25730,TRUE|25740,TRUE|25750,TRUE|25990,TRUE|26010,TRUE|26040,TRUE|26050,TRUE|26057,FALSE|26060,TRUE|26070,TRUE|26077,FALSE|26080,TRUE|26090,TRUE|26100,TRUE|26140,TRUE|26150,TRUE|26180,TRUE|26190,TRUE|26197,TRUE|26200,TRUE|26300,TRUE|26309,TRUE|26320,TRUE|26330,TRUE|26340,TRUE|26350,TRUE|26360,TRUE|26370,TRUE|26400,TRUE|26407,FALSE|26409,FALSE|26410,TRUE|26430,FALSE|26450,FALSE|26460,FALSE|26500,TRUE|26507,FALSE|26509,TRUE|26600,TRUE|26607,FALSE|26609,FALSE|26610,TRUE|26620,TRUE|26630,TRUE|26640,TRUE|26650,TRUE|26680,TRUE|26690,TRUE|26700,TRUE|26707,FALSE|26709,FALSE|26800,TRUE|26807,FALSE|26809,FALSE|26810,TRUE|26820,TRUE|26900,TRUE|26907,FALSE|27000,FALSE|27007,FALSE|27009,FALSE|27010,FALSE|27020,FALSE|27030,FALSE|27037,FALSE|27040,FALSE|27050,FALSE|27060,FALSE|27070,FALSE|27090,FALSE|27100,TRUE|27109,FALSE|27150,FALSE|27200,TRUE|27207,FALSE|27209,FALSE|27210,TRUE|27300,TRUE|27307,FALSE|27310,TRUE|27400,TRUE|27500,TRUE|27600,TRUE|27607,FALSE|27609,FALSE|27610,TRUE|27620,TRUE|27630,TRUE|27650,TRUE|27660,TRUE|28000,TRUE|28007,FALSE|28009,TRUE|28010,TRUE|28020,TRUE|28030,TRUE|28040,TRUE|28050,TRUE|28057,FALSE|28059,FALSE|28100,TRUE|28200,TRUE|28300,TRUE|28309,TRUE|28310,TRUE|28320,TRUE|28330,TRUE|28340,TRUE|28380,TRUE|28387,FALSE|28400,TRUE|28407,FALSE|28409,TRUE|28500,TRUE|28509,TRUE|28600,TRUE|28609,FALSE|28610,TRUE|28620,TRUE|28700,TRUE|28707,FALSE|28709,FALSE|28730,TRUE|28740,TRUE|28750,FALSE|28800,FALSE|39000,TRUE|39007,FALSE|39009,TRUE|39010,TRUE|39100,TRUE|39107,FALSE|39200,TRUE|49000,FALSE|69000,FALSE|69009,FALSE|30000,TRUE|30010,TRUE|30020,TRUE|30100,TRUE|30200,TRUE|30250,TRUE|30300,TRUE|30350,TRUE|30450,TRUE|30502,TRUE|30503,TRUE|30504,TRUE|30505,TRUE|30506,TRUE|30508,TRUE|30510,TRUE|30512,TRUE|30516,TRUE|30517,TRUE|30518,TRUE|30519,TRUE|30520,TRUE|30524,TRUE|30532,TRUE|30534,TRUE|30536,TRUE|30540,TRUE|30542,TRUE|30546,TRUE|30548,TRUE|30550,TRUE|30551,TRUE|30552,TRUE|30554,TRUE|30556,TRUE|30560,TRUE|30564,TRUE|30570,TRUE|30576,TRUE|30580,TRUE|30582,TRUE|30586,TRUE|30590,TRUE|30592,TRUE|30594,TRUE|30596,TRUE|30600,TRUE|30604,TRUE|30606,TRUE|30609,TRUE|30610,TRUE|30612,TRUE|30614,TRUE|30620,TRUE|30621,TRUE|30622,TRUE|30626,TRUE|30628,TRUE|30630,TRUE|30632,TRUE|30634,TRUE|30644,TRUE|30646,TRUE|30648,TRUE|30656,TRUE|30658,TRUE|30660,TRUE|30662,TRUE|30664,TRUE|30668,TRUE|30670,TRUE|30673,TRUE|30674,TRUE|30676,TRUE|30690,TRUE|30700,FALSE|30710,FALSE|30720,FALSE|30730,FALSE|30740,FALSE|30750,FALSE|30760,FALSE|30770,FALSE|30780,FALSE|30790,FALSE|30800,FALSE|30810,FALSE|30820,FALSE|30830,FALSE|30840,FALSE|30900,FALSE|30902,FALSE|30904,FALSE|30906,FALSE|30908,FALSE|30910,FALSE|30912,FALSE|30988,TRUE|30990,TRUE|31000,TRUE|31007,FALSE|31009,TRUE|31050,TRUE|31100,TRUE|31150,TRUE|31200,TRUE|31250,TRUE|31300,TRUE|31350,TRUE|31400,TRUE|31407,FALSE|31409,TRUE|31450,TRUE|31500,TRUE|31550,TRUE|31560,TRUE|31600,TRUE|31610,TRUE|31650,TRUE|31700,TRUE|31750,TRUE|31800,TRUE|31850,TRUE|31900,TRUE|31907,FALSE|31909,TRUE|31910,TRUE|31950,TRUE|32000,TRUE|32040,TRUE|32100,TRUE|32200,TRUE|32300,FALSE|32400,TRUE|32407,FALSE|32500,TRUE|32600,TRUE|32610,TRUE|32700,TRUE|32800,TRUE|32900,TRUE|33000,TRUE|33007,FALSE|33009,FALSE|33020,TRUE|33100,TRUE|33300,TRUE|33307,FALSE|33320,TRUE|33400,TRUE|33420,TRUE|33500,TRUE|33600,TRUE|33700,TRUE|33800,TRUE|34000,TRUE|34007,FALSE|34008,FALSE|34009,FALSE|34100,TRUE|34140,TRUE|34200,TRUE|34250,TRUE|34300,TRUE|34307,FALSE|34310,TRUE|34350,TRUE|34400,TRUE|34500,TRUE|34510,TRUE|34600,TRUE|34607,FALSE|34650,TRUE|34700,TRUE|34750,TRUE|34800,TRUE|34850,TRUE|34900,TRUE|35000,TRUE|35007,FALSE|35009,TRUE|35300,TRUE|35350,TRUE|35400,TRUE|35500,TRUE|35507,FALSE|35600,TRUE|35800,TRUE|35900,TRUE|35907,FALSE|35909,TRUE|35950,TRUE|36000,TRUE|36007,FALSE|36008,TRUE|36009,TRUE|36020,TRUE|36100,TRUE|36110,TRUE|36200,TRUE|36207,FALSE|36209,TRUE|36300,TRUE|36307,FALSE|36309,TRUE|36400,TRUE|36500,TRUE|36600,TRUE|36700,TRUE|36750,TRUE|36800,TRUE|1000,TRUE|1007,TRUE|1009,TRUE|1500,TRUE|1502,TRUE|1503,TRUE|1504,TRUE|1505,TRUE|1506,TRUE|1508,TRUE|1512,TRUE|1514,TRUE|1516,TRUE|1517,TRUE|1518,TRUE|1524,TRUE|1529,TRUE|1532,TRUE|1538,TRUE|1540,TRUE|1542,TRUE|1546,TRUE|1550,TRUE|1551,TRUE|1556,TRUE|1560,TRUE|1564,TRUE|1570,TRUE|1572,TRUE|1576,TRUE|1578,TRUE|1582,TRUE|1586,TRUE|1590,TRUE|1592,TRUE|1594,TRUE|1596,TRUE|1598,TRUE|1600,TRUE|1604,TRUE|1606,TRUE|1608,TRUE|1609,TRUE|1610,TRUE|1612,TRUE|1614,TRUE|1620,TRUE|1622,TRUE|1626,TRUE|1628,TRUE|1630,TRUE|1632,TRUE|1634,TRUE|1644,TRUE|1646,TRUE|1648,TRUE|1660,TRUE|1664,TRUE|1670,TRUE|1672,TRUE|1673,TRUE|1674,TRUE|1676,TRUE|1680,TRUE|1694,TRUE|2000,TRUE|2100,TRUE|2200,TRUE|2400,TRUE|2450,TRUE|2500,TRUE|2600,TRUE|2607,FALSE|2609,TRUE|2700,TRUE|2707,TRUE|2709,TRUE|2800,TRUE|10000,TRUE|10050,TRUE|10100,TRUE|10150,TRUE|10200,TRUE|10250,TRUE|10300,TRUE|10350,TRUE|10400,TRUE|10450,TRUE|10460,TRUE|10470,TRUE|10500,TRUE|10502,TRUE|10503,TRUE|10504,TRUE|10505,TRUE|10506,TRUE|10508,TRUE|10512,TRUE|10514,TRUE|10516,TRUE|10518,TRUE|10524,TRUE|10534,TRUE|10538,TRUE|10540,TRUE|10542,TRUE|10546,TRUE|10550,TRUE|10551,TRUE|10552,TRUE|10558,TRUE|10560,TRUE|10564,TRUE|10566,TRUE|10570,TRUE|10576,TRUE|10578,TRUE|10582,TRUE|10590,TRUE|10592,TRUE|10593,TRUE|10594,TRUE|10596,TRUE|10600,TRUE|10604,TRUE|10609,TRUE|10610,TRUE|10612,TRUE|10620,TRUE|10622,TRUE|10626,TRUE|10628,TRUE|10634,TRUE|10646,TRUE|10648,TRUE|10660,TRUE|10661,TRUE|10662,TRUE|10670,TRUE|10672,TRUE|10673,TRUE|10674,TRUE|10676,TRUE|10690,TRUE|10700,FALSE|10710,FALSE|10720,FALSE|10730,FALSE|10740,FALSE|10750,FALSE|10760,FALSE|10770,FALSE|10780,FALSE|10790,FALSE|10800,FALSE|10810,FALSE|10820,FALSE|10830,FALSE|10840,FALSE|10850,FALSE|10910,FALSE|10920,FALSE|10990,TRUE|11000,TRUE|11010,TRUE|11020,TRUE|11050,TRUE|11060,TRUE|11100,TRUE|11200,TRUE|11300,TRUE|11400,TRUE|11409,TRUE|11500,TRUE|11600,TRUE|11609,TRUE|11700,TRUE|11800,TRUE|11900,TRUE|11910,TRUE|11920,TRUE|11950,TRUE|11960,TRUE|12000,TRUE|12100,TRUE|12200,TRUE|12300,TRUE|12700,FALSE|12710,FALSE|12720,FALSE|12990,TRUE|13000,TRUE|13009,TRUE|13020,TRUE|13050,TRUE|13100,TRUE|13110,TRUE|13200,TRUE|13210,TRUE|13220,TRUE|13300,TRUE|13310,TRUE|13400,TRUE|13409,TRUE|13500,TRUE|13600,TRUE|13700,TRUE|13800,TRUE|14000,TRUE|14007,FALSE|14009,TRUE|14020,TRUE|14100,TRUE|14110,TRUE|14120,TRUE|14200,TRUE|14300,TRUE|14310,TRUE|14320,TRUE|14400,TRUE|88000,FALSE|88100,FALSE|88200,FALSE|88300,FALSE|88400,FALSE|88450,FALSE|88460,FALSE|88500,FALSE|88502,FALSE|88504,FALSE|88505,FALSE|88506,FALSE|88508,FALSE|88510,FALSE|88512,FALSE|88514,FALSE|88516,FALSE|88518,FALSE|88520,FALSE|88526,FALSE|88527,FALSE|88532,FALSE|88534,FALSE|88538,FALSE|88540,FALSE|88546,FALSE|88550,FALSE|88551,FALSE|88552,FALSE|88554,FALSE|88556,FALSE|88558,FALSE|88560,FALSE|88564,FALSE|88566,FALSE|88568,FALSE|88570,FALSE|88572,FALSE|88576,FALSE|88580,FALSE|88582,FALSE|88586,FALSE|88590,FALSE|88592,FALSE|88594,FALSE|88596,FALSE|88598,FALSE|88600,FALSE|88604,FALSE|88606,FALSE|88608,FALSE|88609,FALSE|88612,FALSE|88614,FALSE|88617,FALSE|88618,FALSE|88620,FALSE|88621,FALSE|88622,FALSE|88624,FALSE|88626,FALSE|88630,FALSE|88632,FALSE|88634,FALSE|88644,FALSE|88646,FALSE|88648,FALSE|88656,FALSE|88662,FALSE|88670,FALSE|88672,FALSE|88673,FALSE|88675,FALSE|88676,FALSE|88680,FALSE|88690,FALSE|88700,FALSE|88721,FALSE|88722,FALSE|88723,FALSE|88724,FALSE|88725,FALSE|88757,FALSE|88758,FALSE|88759,FALSE|88760,FALSE|88761,FALSE|88762,FALSE|88763,FALSE|88764,FALSE|88765,FALSE|88766,FALSE|88767,FALSE|88768,FALSE|88769,FALSE|88770,FALSE|88771,FALSE|88772,FALSE|88773,FALSE|88774,FALSE|88775,FALSE|88776,FALSE|88777,FALSE|88778,FALSE|88779,FALSE|88780,FALSE|88781,FALSE|88782,FALSE|88783,FALSE|88784,FALSE|88785,FALSE|88786,FALSE|88787,FALSE|88788,FALSE|88789,FALSE|88790,FALSE|88800,FALSE|88801,FALSE|88802,FALSE|88803,FALSE|88804,FALSE|88805,FALSE|88806,FALSE|88807,FALSE|88808,FALSE|88809,FALSE|88810,FALSE|88811,FALSE|88812,FALSE|88813,FALSE|88814,FALSE|88815,FALSE|88816,FALSE|88817,FALSE|88818,FALSE|88819,FALSE|88820,FALSE|88821,FALSE|88822,FALSE|88823,FALSE|88824,FALSE|88825,FALSE|88826,FALSE|88827,FALSE|88828,FALSE|88829,FALSE|88830,FALSE|88831,FALSE|88832,FALSE|88833,FALSE|88834,FALSE|88835,FALSE|88836,FALSE|88837,FALSE|88838,FALSE|88839,FALSE|88840,FALSE|88841,FALSE|88842,FALSE|88843,FALSE|88844,FALSE|88845,FALSE|88846,FALSE|88847,FALSE|88848,FALSE|88849,FALSE|88850,FALSE|88851,FALSE|88852,FALSE|88853,FALSE|88854,FALSE|88855,FALSE|88856,FALSE|88857,FALSE|88858,FALSE|88859,FALSE|88860,FALSE|88861,FALSE|88862,FALSE|88863,FALSE|88864,FALSE|88865,FALSE|88866,FALSE|88867,FALSE|88868,FALSE|88869,FALSE|88870,FALSE|88871,FALSE|88872,FALSE|88873,FALSE|88874,FALSE|88875,FALSE|88900,FALSE|88901,FALSE|88902,FALSE|88903,FALSE|88904,FALSE|88905,FALSE|88906,FALSE|88988,FALSE|88990,FALSE|88991,FALSE|88992,FALSE|88993,FALSE|88994,FALSE|88995,FALSE|88996,FALSE|88997,FALSE|88998,FALSE|88999,FALSE|89000,FALSE|89007,FALSE|89009,FALSE|89050,FALSE|89057,FALSE|89058,FALSE|89059,FALSE|89100,FALSE|89107,FALSE|89108,FALSE|89109,FALSE|89130,FALSE|89137,FALSE|89138,FALSE|89139,FALSE|89150,FALSE|89157,FALSE|89158,FALSE|89159,FALSE|89200,FALSE|89207,FALSE|89208,FALSE|89209,FALSE|89250,FALSE|89257,FALSE|89258,FALSE|89259,FALSE|89260,FALSE|89300,FALSE|89307,FALSE|89308,FALSE|89309,FALSE|89320,FALSE|89327,FALSE|89328,FALSE|89329,FALSE|89330,FALSE|89337,FALSE|89338,FALSE|89339,FALSE|89500,FALSE|89507,FALSE|89508,FALSE|89509,FALSE|89600,FALSE|89607,FALSE|89608,FALSE|89609,FALSE|89650,FALSE|89657,FALSE|89658,FALSE|89659,FALSE|89700,FALSE|89707,FALSE|89708,FALSE|89709,FALSE|89720,FALSE|89727,FALSE|89728,FALSE|89729,FALSE|89740,FALSE|89747,FALSE|89748,FALSE|89749,FALSE|89760,FALSE|89767,FALSE|89768,FALSE|89769,FALSE|89800,FALSE|89807,FALSE|89808,FALSE|89809,FALSE|89850,FALSE|89857,FALSE|89858,FALSE|89859,FALSE|89900,FALSE|89907,FALSE|89908,FALSE|89909,FALSE|89950,FALSE|89957,FALSE|89958,FALSE|89959,FALSE|90000,FALSE|90008,FALSE|90009,FALSE|90100,FALSE|90107,FALSE|90108,FALSE|90109,FALSE|90200,FALSE|90208,FALSE|90300,FALSE|90307,FALSE|90308,FALSE|90400,FALSE|90508,FALSE|90509,FALSE|90700,FALSE|90701,FALSE|90702,FALSE|90703,FALSE|90704,FALSE|90705,FALSE|90706,FALSE|90707,FALSE|90708,FALSE|90709,FALSE|90710,FALSE|90711,FALSE|90712,FALSE|90713,FALSE|90714,FALSE|90715,FALSE|90716,FALSE|90717,FALSE|90718,FALSE|90719,FALSE|90720,FALSE|90721,FALSE|90722,FALSE|90723,FALSE|90724,FALSE|90725,FALSE|90726,FALSE|90727,FALSE|90728,FALSE|90729,FALSE|90730,FALSE|90731,FALSE|90732,FALSE|90733,FALSE|90734,FALSE|90735,FALSE|90736,FALSE|90737,FALSE|90738,FALSE|90739,FALSE|90740,FALSE|90741,FALSE|91000,FALSE|91007,FALSE|91008,FALSE|91009,FALSE|91010,FALSE|91011,FALSE|91012,FALSE|91013,FALSE|91014,FALSE|91015,FALSE|91016,FALSE|91017,FALSE|91018,FALSE|91019,FALSE|91020,FALSE|91021,FALSE|91022,FALSE|91023,FALSE|91024,FALSE|91025,FALSE|91026,FALSE|91027,FALSE|91028,FALSE|91029,FALSE|91030,FALSE|91031,FALSE|91032,FALSE|91033,FALSE|91034,FALSE|91035,FALSE|91036,FALSE|91037,FALSE|91038,FALSE|91039,FALSE|91040,FALSE|91041,FALSE|91042,FALSE|91043,FALSE|91044,FALSE|91045,FALSE|91046,FALSE|91047,FALSE|91048,FALSE|91049,FALSE|91050,FALSE|91051,FALSE|91052,FALSE|91053,FALSE|91054,FALSE|91055,FALSE|91056,FALSE|91100,FALSE|91120,FALSE|91107,FALSE|91109,FALSE|91110,FALSE|91111,FALSE|91112,FALSE|91113,FALSE|91114,FALSE|91115,FALSE|91116,FALSE|91117,FALSE|91118,FALSE|91119,FALSE|91121,FALSE|91122,FALSE|91123,FALSE|91124,FALSE|91125,FALSE|91126,FALSE|91127,FALSE|91128,FALSE|91150,FALSE|91200,FALSE|91207,FALSE|91208,FALSE|91209,FALSE|91300,FALSE|91307,FALSE|91308,FALSE|93000,FALSE|93010,FALSE|93050,FALSE|93100,FALSE|93107,FALSE|93150,FALSE|93200,FALSE|93250,FALSE|93257,FALSE|93300,FALSE|93307,FALSE|93350,FALSE|93400,FALSE|93407,FALSE|93450,FALSE|93457,FALSE|93500,FALSE|93501,FALSE|93502,FALSE|93503,FALSE|93504,FALSE|93505,FALSE|93506,FALSE|93507,FALSE|93508,FALSE|93514,FALSE|93516,FALSE|93517,FALSE|93518,FALSE|93519,FALSE|93520,FALSE|93527,FALSE|93529,FALSE|93532,FALSE|93540,FALSE|93550,FALSE|93551,FALSE|93552,FALSE|93554,FALSE|93556,FALSE|93558,FALSE|93560,FALSE|93564,FALSE|93566,FALSE|93570,FALSE|93572,FALSE|93576,FALSE|93578,FALSE|93582,FALSE|93586,FALSE|93590,FALSE|93592,FALSE|93594,FALSE|93596,FALSE|93600,FALSE|93601,FALSE|93604,FALSE|93606,FALSE|93608,FALSE|93609,FALSE|93610,FALSE|93612,FALSE|93614,FALSE|93618,FALSE|93619,FALSE|93620,FALSE|93626,FALSE|93628,FALSE|93632,FALSE|93634,FALSE|93648,FALSE|93658,FALSE|93660,FALSE|93661,FALSE|93662,FALSE|93668,FALSE|93670,FALSE|93672,FALSE|93675,FALSE|93677,FALSE|93690,FALSE|93694,FALSE|93700,FALSE|93702,FALSE|93704,FALSE|93706,FALSE|93708,FALSE|93710,FALSE|93712,FALSE|93714,FALSE|93716,FALSE|93718,FALSE|93720,FALSE|93722,FALSE|93724,FALSE|93726,FALSE|93728,FALSE|93730,FALSE|93732,FALSE|93734,FALSE|93736,FALSE|93738,FALSE|93740,FALSE|93742,FALSE|93744,FALSE|93746,FALSE|93748,FALSE|93750,FALSE|93752,FALSE|93754,FALSE|93756,FALSE|93758,FALSE|93760,FALSE|93762,FALSE|93764,FALSE|93900,FALSE|93902,FALSE|93904,FALSE|93906,FALSE|93908,FALSE|93910,FALSE|93912,FALSE|93914,FALSE|93916,FALSE|93990,FALSE|94000,FALSE|94007,FALSE|94009,FALSE|94111,FALSE|94200,FALSE|94300,FALSE|94500,FALSE|94507,FALSE|94509,FALSE|94600,FALSE|94607,FALSE|94650,FALSE|94700,FALSE|94707,FALSE|94709,FALSE|94750,FALSE|94760,FALSE|94800,FALSE|94807,FALSE|94809,FALSE|94850,FALSE|94900,FALSE|94950,FALSE|95000,FALSE|95007,FALSE|95008,FALSE|95009,FALSE|95300,FALSE|95400,FALSE|95407,FALSE|95409,FALSE|95500,FALSE|95600,FALSE|95700,FALSE|95707,FALSE|95709,FALSE|95800,FALSE|95807,FALSE|95900,FALSE|96000,FALSE|96007,FALSE|96008,FALSE|96009,FALSE|96010,FALSE|96100,FALSE|96107,FALSE|96108,FALSE|96109,FALSE|96150,FALSE|96200,FALSE|96250,FALSE|96300,FALSE|96307,FALSE|96309,FALSE|96350,FALSE|96400,FALSE|96407,FALSE|96410,FALSE|96500,FALSE|96507,FALSE|96508,FALSE|96509,FALSE|96510,FALSE|96600,FALSE|96609,FALSE|96700,FALSE|96707,FALSE|96709,FALSE|96800,FALSE|96807,FALSE|96809,FALSE|96850,FALSE|96857,FALSE|96900,FALSE|96950,FALSE|97000,FALSE|97007,FALSE|97008,FALSE|97009,FALSE|97010,FALSE|97011,FALSE|97012,FALSE|97013,FALSE|97014,FALSE|97015,FALSE|97100,FALSE|97200,FALSE|97300,FALSE|97307,FALSE|98000,FALSE|98007,FALSE|98008,FALSE|98009,FALSE|98050,FALSE|98057,FALSE|98058,FALSE|98059,FALSE|98060,FALSE|98070,FALSE|98100,FALSE|98107,FALSE|98109,FALSE|98150,FALSE|98157,FALSE|98159,FALSE|98200,FALSE|98207,FALSE|98300,FALSE|98700,FALSE|98707,FALSE|98708,FALSE|98709,FALSE|98750,FALSE|98800,FALSE|98850,TRUE|98857,FALSE|98859,FALSE|40000,TRUE|40100,TRUE|40150,TRUE|40200,TRUE|40160,TRUE|40170,TRUE|40300,TRUE|40400,TRUE|43500,TRUE|40450,TRUE|40460,TRUE|40470,TRUE|40500,TRUE|40502,TRUE|40551,TRUE|40592,TRUE|40596,TRUE|40604,TRUE|40610,TRUE|40612,TRUE|40620,TRUE|40622,TRUE|40632,TRUE|40664,TRUE|40674,TRUE|40690,TRUE|40700,FALSE|40702,FALSE|40704,FALSE|40706,FALSE|40708,FALSE|40710,FALSE|40712,FALSE|40714,FALSE|40716,FALSE|40718,FALSE|40720,FALSE|40722,FALSE|40724,FALSE|40726,FALSE|40728,FALSE|40730,FALSE|40732,FALSE|40800,FALSE|40802,FALSE|40804,FALSE|40806,FALSE|40808,FALSE|40810,FALSE|40990,FALSE|41000,TRUE|41050,TRUE|41100,TRUE|41150,TRUE|41200,TRUE|41250,TRUE|41300,TRUE|41400,TRUE|41506,TRUE|41560,TRUE|41586,TRUE|41672,TRUE|41700,FALSE|41710,FALSE|41720,FALSE|41900,FALSE|41902,FALSE|41904,FALSE|41906,FALSE|41908,FALSE|41910,FALSE|41912,FALSE|41914,FALSE|41916,FALSE|41918,FALSE|41990,FALSE|42000,TRUE|42009,TRUE|42100,TRUE|42200,TRUE|42300,TRUE|42500,TRUE|43800,TRUE|47100,TRUE|42700,TRUE|42507,FALSE|42509,FALSE|42600,TRUE|42610,TRUE|44100,TRUE|42800,TRUE|42920,TRUE|42940,FALSE|42960,TRUE|43000,TRUE|43007,FALSE|43009,FALSE|43100,TRUE|43200,TRUE|43207,TRUE|43300,TRUE|43400,TRUE|43558,TRUE|43600,TRUE|43650,TRUE|43657,TRUE|43659,TRUE|43700,TRUE|43807,TRUE|43900,TRUE|43950,TRUE|44000,TRUE|44010,TRUE|44020,TRUE|44110,TRUE|44200,TRUE|44300,TRUE|45100,TRUE|45000,TRUE|45200,TRUE|45207,TRUE|45300,TRUE|45400,TRUE|45500,TRUE|45700,TRUE|45507,FALSE|45600,TRUE|45607,TRUE|45609,TRUE|45620,TRUE|45800,TRUE|46000,TRUE|46050,TRUE|46100,TRUE|46150,TRUE|46200,TRUE|46300,TRUE|46350,TRUE|46400,TRUE|46506,TRUE|46547,TRUE|46549,TRUE|46551,TRUE|46564,TRUE|46582,TRUE|46598,TRUE|46662,TRUE|46667,TRUE|46668,TRUE|46672,TRUE|46675,TRUE|46700,TRUE|46710,TRUE|46720,TRUE|46730,TRUE|46740,TRUE|46750,TRUE|46760,TRUE|46770,TRUE|46780,TRUE|46781,TRUE|46782,TRUE|46783,TRUE|46784,TRUE|46785,TRUE|46786,TRUE|46787,TRUE|46788,TRUE|46789,TRUE|46790,TRUE|46791,TRUE|46792,TRUE|46793,TRUE|46794,TRUE|46795,TRUE|46796,TRUE|46797,TRUE|46798,TRUE|46799,TRUE|46800,TRUE|46801,TRUE|46802,TRUE|46803,TRUE|46804,TRUE|46805,TRUE|46806,TRUE|46860,TRUE|46870,TRUE|46960,TRUE|46962,TRUE|46964,TRUE|46966,TRUE|46968,TRUE|46970,TRUE|46972,TRUE|46974,TRUE|46976,TRUE|46978,TRUE|47000,TRUE|47107,TRUE|47109,TRUE|47110,TRUE|47120,TRUE|47130,TRUE|47140,TRUE|47150,TRUE|47160,TRUE|47170,TRUE|47180,TRUE|47190,TRUE|47200,TRUE|47300,TRUE|47301,TRUE|47307,TRUE|47400,TRUE|47410,TRUE|47500,TRUE|47507,FALSE|47600,TRUE|47610,TRUE|47620,TRUE|47630,TRUE|47640,TRUE|47650,TRUE|47800,TRUE|47810,TRUE|47820,TRUE|47830,TRUE|48000,TRUE|48010,TRUE|48020,TRUE|48050,TRUE|48100,TRUE|48200,TRUE|48300,TRUE|63000,TRUE|63100,TRUE|64000,TRUE|68000,TRUE|68100,TRUE|20000,TRUE|20050,TRUE|20100,TRUE|20200,TRUE|20300,TRUE|20400,TRUE|20500,TRUE|20502,TRUE|20503,TRUE|20504,TRUE|20505,TRUE|20506,TRUE|20508,TRUE|20512,TRUE|20514,TRUE|20516,TRUE|20517,TRUE|20518,TRUE|20519,TRUE|20520,TRUE|20532,TRUE|20534,TRUE|20536,TRUE|20538,TRUE|20540,TRUE|20542,TRUE|20546,TRUE|20548,TRUE|20550,TRUE|20551,TRUE|20552,TRUE|20554,TRUE|20556,TRUE|20560,TRUE|20564,TRUE|20566,TRUE|20568,TRUE|20570,TRUE|20572,TRUE|20576,TRUE|20578,TRUE|20582,TRUE|20586,TRUE|20590,TRUE|20592,TRUE|20594,TRUE|20596,TRUE|20598,TRUE|20600,TRUE|20604,TRUE|20606,TRUE|20608,TRUE|20609,TRUE|20610,TRUE|20612,TRUE|20614,TRUE|20618,TRUE|20620,TRUE|20622,TRUE|20626,TRUE|20628,TRUE|20630,TRUE|20632,TRUE|20646,TRUE|20648,TRUE|20656,TRUE|20658,TRUE|20660,TRUE|20661,TRUE|20662,TRUE|20664,TRUE|20668,TRUE|20670,TRUE|20672,TRUE|20673,TRUE|20674,TRUE|20675,TRUE|20676,TRUE|20680,TRUE|20690,TRUE|20698,TRUE|20700,FALSE|20710,FALSE|20720,FALSE|20900,FALSE|20902,FALSE|20904,FALSE|20906,FALSE|20908,FALSE|20910,FALSE|20912,FALSE|20914,FALSE|20916,FALSE|20918,FALSE|20920,FALSE|20922,FALSE|20924,FALSE|20926,FALSE|20928,FALSE|20930,FALSE|20990,TRUE|21000,TRUE|21009,TRUE|21010,TRUE|21020,TRUE|21030,TRUE|21040,TRUE|21060,TRUE|21070,TRUE|21080,TRUE|21090,FALSE|21100,TRUE|21109,TRUE|21200,TRUE|21209,TRUE|21300,TRUE|21309,TRUE|21400,TRUE|21450,TRUE|21500,TRUE|21600,TRUE|21700,TRUE|21800,TRUE|21810,TRUE|22000,TRUE|22020,TRUE|22100,TRUE|22107,FALSE|22109,FALSE|22200,TRUE|22300,TRUE|22307,FALSE|22309,TRUE|23000,TRUE|23007,FALSE|23009,TRUE|23050,TRUE|23100,TRUE|23200,TRUE|23300,TRUE|23400,TRUE|24000,TRUE|24007,TRUE|24009,TRUE|24050,TRUE|24060,TRUE|24100,TRUE|24107,TRUE|24109,TRUE|24200,TRUE|24207,FALSE|24209,TRUE|24300,TRUE|50000,TRUE|50050,TRUE|50088,TRUE|50100,TRUE|50150,TRUE|50200,TRUE|50250,TRUE|50300,TRUE|50350,TRUE|50400,TRUE|50450,TRUE|50460,TRUE|50470,TRUE|50480,TRUE|50490,TRUE|50500,TRUE|50502,TRUE|50504,TRUE|50505,TRUE|50506,TRUE|50507,TRUE|50508,TRUE|50510,TRUE|50512,TRUE|50514,TRUE|50515,TRUE|50519,TRUE|50530,TRUE|50532,TRUE|50534,TRUE|50536,TRUE|50538,TRUE|50544,TRUE|50546,TRUE|50548,TRUE|50550,TRUE|50551,TRUE|50552,TRUE|50554,TRUE|50556,TRUE|50560,TRUE|50562,TRUE|50564,TRUE|50566,TRUE|50568,TRUE|50572,TRUE|50578,TRUE|50580,TRUE|50582,TRUE|50586,TRUE|50588,TRUE|50590,TRUE|50592,TRUE|50594,TRUE|50598,TRUE|50600,TRUE|50603,TRUE|50604,TRUE|50608,TRUE|50609,TRUE|50612,TRUE|50614,TRUE|50620,TRUE|50621,TRUE|50622,TRUE|50623,TRUE|50626,TRUE|50632,TRUE|50634,TRUE|50640,TRUE|50644,TRUE|50646,TRUE|50648,TRUE|50650,TRUE|50652,TRUE|50653,TRUE|50658,TRUE|50660,TRUE|50662,TRUE|50664,TRUE|50670,TRUE|50672,TRUE|50673,TRUE|50676,TRUE|50677,TRUE|50678,TRUE|50680,TRUE|50682,TRUE|50684,TRUE|50688,TRUE|50694,TRUE|50695,TRUE|50700,FALSE|50702,FALSE|50704,FALSE|50706,FALSE|50708,FALSE|50710,FALSE|50712,FALSE|50714,FALSE|50716,FALSE|50718,FALSE|50720,FALSE|50722,FALSE|50724,FALSE|50726,FALSE|50728,FALSE|50730,FALSE|50732,FALSE|50734,FALSE|50735,FALSE|50736,FALSE|50738,FALSE|50740,FALSE|50742,FALSE|50744,FALSE|50746,FALSE|50748,FALSE|50750,FALSE|50752,FALSE|50754,FALSE|50756,FALSE|50758,FALSE|50760,FALSE|50762,FALSE|50764,FALSE|50766,FALSE|50768,FALSE|50770,FALSE|50772,FALSE|50774,FALSE|50776,FALSE|50778,FALSE|50780,FALSE|50782,FALSE|50784,FALSE|50786,FALSE|50788,FALSE|50790,FALSE|50792,FALSE|50794,FALSE|50796,FALSE|50798,FALSE|50800,FALSE|50802,FALSE|50804,FALSE|50806,FALSE|50808,FALSE|50810,FALSE|50812,FALSE|50814,FALSE|50816,FALSE|50818,FALSE|50901,FALSE|50902,FALSE|50903,FALSE|50904,FALSE|50905,FALSE|50906,FALSE|50907,FALSE|50908,FALSE|50909,FALSE|50910,FALSE|50911,FALSE|50912,FALSE|50913,FALSE|50914,FALSE|50915,FALSE|50916,FALSE|50917,FALSE|50918,FALSE|50919,FALSE|50920,FALSE|50921,FALSE|50922,FALSE|50923,FALSE|50924,FALSE|50925,FALSE|50926,FALSE|50927,FALSE|50928,FALSE|50929,FALSE|50930,FALSE|50931,FALSE|50932,FALSE|50933,FALSE|50934,FALSE|50935,FALSE|50936,FALSE|50937,FALSE|50938,FALSE|50939,FALSE|50940,FALSE|50941,FALSE|50942,FALSE|50943,FALSE|50944,FALSE|50945,FALSE|50946,FALSE|50947,FALSE|50948,FALSE|50949,FALSE|50950,FALSE|50988,FALSE|50989,FALSE|50990,FALSE|51000,TRUE|51100,TRUE|51200,TRUE|51700,FALSE|51990,FALSE|52000,TRUE|52100,TRUE|52200,TRUE|52700,FALSE|53000,TRUE|53100,TRUE|53200,TRUE|53300,TRUE|53700,FALSE|53800,FALSE|53990,FALSE|54000,TRUE|54100,TRUE|54200,TRUE|55000,TRUE|55100,TRUE|55188,TRUE|55200,TRUE|55300,TRUE|55700,FALSE|55710,FALSE|55720,FALSE|55900,FALSE|55902,FALSE|55904,FALSE|55906,FALSE|55908,FALSE|55910,FALSE|55912,FALSE|55914,FALSE|55916,FALSE|55918,FALSE|55920,FALSE|55922,FALSE|55924,FALSE|55926,FALSE|55928,FALSE|55930,FALSE|55932,FALSE|55934,FALSE|55990,FALSE|56000,TRUE|56100,TRUE|57000,TRUE|57100,TRUE|57990,FALSE|58000,TRUE|58100,TRUE|58200,TRUE|58700,TRUE|58990,TRUE|59000,TRUE|59100,TRUE|59200,TRUE|59700,TRUE|59800,FALSE|59990,FALSE|60000,TRUE|87000,FALSE|87008,FALSE|87011,FALSE|87012,FALSE|87013,FALSE|87014,FALSE|87015,FALSE|87016,FALSE|87017,FALSE|87018,FALSE|87019,FALSE|87020,FALSE|87021,FALSE|87022,FALSE|87023,FALSE|87024,FALSE|87025,FALSE|87026,FALSE|87027,FALSE|87028,FALSE|87029,FALSE|87030,FALSE|87031,FALSE|87032,FALSE|87033,FALSE|62000,TRUE|62050,TRUE|62100,TRUE|62150,TRUE|62200,TRUE|62250,TRUE|62300,TRUE|62502,TRUE|62504,TRUE|62505,TRUE|62506,TRUE|62510,TRUE|62512,TRUE|62514,TRUE|62516,TRUE|62517,TRUE|62518,TRUE|62519,TRUE|62520,TRUE|62522,TRUE|62524,TRUE|62526,TRUE|62527,TRUE|62530,TRUE|62532,TRUE|62536,TRUE|62540,TRUE|62542,TRUE|62546,TRUE|62550,TRUE|62551,TRUE|62564,TRUE|62570,TRUE|62574,TRUE|62576,TRUE|62582,TRUE|62584,TRUE|62590,TRUE|62592,TRUE|62594,TRUE|62596,TRUE|62600,TRUE|62602,TRUE|62604,TRUE|62605,TRUE|62606,TRUE|62607,TRUE|62612,TRUE|62616,TRUE|62618,TRUE|62620,TRUE|62622,TRUE|62623,TRUE|62624,TRUE|62628,TRUE|62630,TRUE|62632,TRUE|62640,TRUE|62644,TRUE|62648,TRUE|62652,TRUE|62654,TRUE|62662,TRUE|62668,TRUE|62670,TRUE|62674,TRUE|62675,TRUE|62676,TRUE|62677,TRUE|62686,TRUE|62690,TRUE|62692,TRUE';
    const arr = str.split('|');
    for (let i = 0;i < arr.length; i++)
      {
        const arr2 = arr[i].split(',');
        if(arr2[0] == expresspostcode && arr2[1] == 'TRUE')
        {
          var checkpostcode = true;
          break;
        }
        else
        {
          var checkpostcode = false;
        }
      }
    if (checkpostcode == true)
    {
      alert('Your postcode is AVAILABLE for Express Shipping!')
    }
    else
    {
      alert('Your postcode is NOT AVAILABLE for Express Shipping ')
    }
   
 
  });


/* ==============================================================================
    TABS
    ============================================================================*/

 $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

/*============================================================================
  Featured collection
==============================================================================*/

window.featuredCollection = {
  init() {
    $('.js-product-slider .products-slider').each((index, value) => {
      const productsPerSlide = $(value).data('products-per-slide');
      const productsLimit = $(value).data('products-limit');
      const productsAvailable = $(value).data('products-available');
      let cellAlign = '';
      let draggable = false;
      let prevNext = false;
      let wrapAround = false;
      let initialIndex = 0;

      // Ensure product media libraries are present
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        },
      ], window.productMedia.setupMedia);

      if (
        (
          productsPerSlide === '2'
          && productsAvailable > productsPerSlide
          && productsLimit > productsPerSlide
        )
        || (
          productsPerSlide === '4'
          && productsAvailable > productsPerSlide
          && productsLimit > productsPerSlide
        )
        || (
          productsPerSlide === '6'
          && productsAvailable > productsPerSlide
          && productsLimit > productsPerSlide
        )
      ) {
        cellAlign = 'left';
      } else {
        cellAlign = 'center';
      }

      if (productsAvailable > productsPerSlide && productsLimit > productsPerSlide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (
        (
          productsPerSlide === '2'
          && productsAvailable > productsPerSlide
        )
        || (
          productsPerSlide === '4'
          && productsAvailable > productsPerSlide
        )
        || (
          productsPerSlide === '6'
          && productsAvailable > productsPerSlide
        )
      ) {
        initialIndex = 0;
      } else if (productsPerSlide === '3' && productsAvailable) {
        initialIndex = 1;
      } else if (productsPerSlide === '5' && productsAvailable) {
        initialIndex = 2;
      } else if (productsPerSlide === '7' && productsAvailable) {
        initialIndex = 3;
      }

      if (window.Shopify.media_queries.medium.matches) {
        cellAlign = 'center';
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(value).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(value).flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable,
        prevNextButtons: prevNext,
        wrapAround,
        cellAlign,
        pageDots: window.usePageDots,
        contain: true,
        freeScroll: true,
        arrowShape: window.arrowSize,
        initialIndex,
      });

      $(value).addClass('slider-initialized');
    });
  },
  unload($target) {
    const $slider = $target.find('.js-product-slider');

    if ($slider.hasClass('flickity-enabled')) {
      $slider.flickity('destroy');
    }
  },
};

/*============================================================================
  Featured promotions
==============================================================================*/
window.featuredPromotions = {
  init() {
    $('.feature-overlay').hover(function () {
      $(this).find('.feature-details').slideDown('100', function () {
        $(this).addClass('reveal-details');
      });
    }, function () {
      $(this).find('.feature-details').removeClass('reveal-details');
      $(this).find('.feature-details').slideUp('100');
    });

    $('.js-featured-promotions').each(function () {
      const $promos = $(this);
      const animationStyle = $(this).data('promo-animation');

      $promos.waypoint(function () {
        $(this.element).find('.feature-section').addClass(`animated ${animationStyle}`);
      }, { offset: '80%' });
    });
  },
};

/*============================================================================
  Slideshow
==============================================================================*/

window.slideshow = {
  init() {
    $('.js-homepage-slideshow').each(function () {
      const $homepageSlider = $(this);
      const settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed') * 1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height'),
      };

      // Initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')) {
        const arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
          adaptiveHeight: settings.adaptiveHeight,
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          autoPlay: settings.slideshowSpeed,
        });

        if (settings.slideshowTextAnimation !== '') {
          const flkty = $homepageSlider.data('flickity');
          setTimeout(() => {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass(`animated ${settings.slideshowTextAnimation}`);
          }, 400);

          $homepageSlider.on('select.flickity', () => {
            if ($homepageSlider.is(':visible')) {
              const currentSlide = flkty.selectedIndex + 1;
              setTimeout(() => {
                $homepageSlider.find('.caption-content').removeClass(`animated ${settings.slideshowTextAnimation}`);
                $homepageSlider.find(`.gallery-cell:nth-child(${currentSlide}) .caption-content`).addClass(`animated ${settings.slideshowTextAnimation}`);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }
    });
  },
  unload($target) {
    const $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');
  },
};

/*============================================================================
  Testimonials
==============================================================================*/

window.testimonials = {
  init() {
    $('.js-testimonial').each(function () {
      const $testimonialSlider = $(this);
      const settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed') * 1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation'),
        adaptiveHeight: $testimonialSlider.data('adaptive-height'),
      };

      if ($('.testimonial-image').length > 0) {
        $('.testimonial-block').each(function () {
          if ($(this).find('.testimonial-image').length === 0) {
            const theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        });
      }

      // Initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')) {
        const arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
          adaptiveHeight: settings.adaptiveHeight,
          wrapAround: true,
          cellAlign: 'left',
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          autoPlay: settings.slideshowSpeed,
        });

        if (settings.slideshowTextAnimation !== '') {
          const flkty = $testimonialSlider.data('flickity');
          setTimeout(() => {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass(`animated ${settings.slideshowTextAnimation}`);
          }, 400);

          $testimonialSlider.on('select.flickity', () => {
            if ($testimonialSlider.is(':visible')) {
              const currentSlide = flkty.selectedIndex + 1;
              setTimeout(() => {
                $testimonialSlider.find('.caption-content').removeClass(`animated ${settings.slideshowTextAnimation}`);
                $testimonialSlider.find(`.gallery-cell:nth-child(${currentSlide}) .caption-content`).addClass(`animated ${settings.slideshowTextAnimation}`);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }
    });
  },
  unload($target) {
    const $slider = $target.find('.js-testimonial');
    $slider.flickity('destroy');
  },
};

/*============================================================================
  Gallery
==============================================================================*/

window.gallery = {
  init() {
    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function () {
      const wrapper = $(this);
      const images = $(this).find('img');
      let imgWidth;
      let imgHeight;

      $('<img />').attr('src', $(images).attr('src')).on('load', function () {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css('flex-basis', imgWidth * 200 / imgHeight);
        $(wrapper).css('flex-grow', imgWidth * 200 / imgHeight);
        $(wrapper).find('i').css('padding-bottom', `${imgHeight / imgWidth * 100}%`);
      });
    });

    if ($('[rel=gallery]').length) {
      $('[rel=gallery]').fancybox({
        baseClass: 'gallery-section__lightbox',
        clickContent: 'nextOrClose',
      });
    }
  },
};

/*============================================================================
  Video
==============================================================================*/
window.video = {
  init() {

    // Set up plyr for newly embedded video
    var featuredVideos = $('[data-video-element]').get();

    var featuredVideoPlayers = Plyr.setup(featuredVideos, {
      controls: window.videoControls,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    // Adds plyr video id to video wrapper
    $.each(featuredVideoPlayers, function(index, player) {
      var id = player.id;
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }

      // When a video is playing, pause any other instances
      player.on('play', function(event) {
        var instance = event.detail.plyr;
        $.each(featuredVideoPlayers, function(index, player) {
          if (instance.id != player.id) {
            player.pause();
          }
        })
      })

      // Moves players from video section into global array
      if (window.globalVideoPlayers) {
        window.globalVideoPlayers.push(player);
      }
    })

    $('[data-video-element]').each(function(index, video) {

      // Variables
      var $video = $(video);
      var $section = $video.parents('.shopify-section').attr('id', id);
      var $videoElement = $section.find($video);
      var $videoWrapper = $videoElement.parents('.video-wrapper');
      var $playButton = $videoWrapper.find('[data-play-button]');
      var $secondaryButton = $videoWrapper.find('[data-secondary-button]');
      var $videoText = $videoWrapper.find('[data-video-text]');
      var $videoTextContainer = $videoWrapper.find('[data-video-text-container]');
      var $image = $videoWrapper.find('.video-wrapper__image');
      var $posterImage = $videoWrapper.data('poster-image-uploaded');
      var aspectRatio = $videoWrapper.data('aspect-ratio');
      var id = $videoWrapper.data('video-src');
      var isAutoplay = $videoWrapper.data('autoplay');
      var isLoopingEnabled = $videoWrapper.data('autoloop');
      var isMuted = $videoWrapper.data('mute-video');

      $.each(featuredVideoPlayers, function(index, player) {
        var videoID;
        var playerID;

        if (player.isYouTube || player.isVimeo) {
          var videoID = $videoWrapper.attr('id');
          var playerID = $(player.elements.original).attr('id');
        } else if (player.isHTML5) {
          var videoID = $videoWrapper.find('[data-plyr-video-id]').data('plyr-video-id');
          var playerID = player.id;
          $videoElement = $section.find('.plyr--video');
        }

        if (playerID == videoID) {

          // Reset play button icon
          $videoWrapper.removeClass('play-button-icon--visible');

          // Autoplay
          if (isAutoplay) {
            // If on desktop or player is YouTube/Vimeo
            if (window.Shopify.media_queries.large.matches || player.isYouTube || player.isVimeo) {

              player.autoplay = true;

              // Hide image
              $image.hide();

              // Show video
              $videoElement.show();

              // If display text over video unchecked
              if ($videoTextContainer.hasClass('display-text-over-video--false')) {
                $videoText.hide();
              } else {
                $videoText.show();
              }

              // Keep play button hidden
              $playButton.hide();

              // HTML5 Mobile Video
            } else if (window.Shopify.media_queries.medium.matches && player.isHTML5) {

              // Hide image
              $image.hide();

              // Show video
              $videoElement.show();

              // Display button so that video can be played
              $playButton.show();

              player.on('play', function() {
                // Show video
                $videoElement.show();

                // Hide play button
                $playButton.hide();
              })
            }
          } else { // If Autoplay disabled
            // If poster image, show image wrapper otherwise hide it
            if ($posterImage) {
              $image.show();
              $videoElement.hide();
            } else {
              $videoElement.show();
            }
          }

          // Clicking image will play video
          $image.on('click', function() {
            // Hide image
            $(this).hide();

            // Show video
            $videoElement.show();

            player.play();
          })

          // Muted
          if (isMuted) {
            player.muted = true;
          }

          // Aspect Ratio
          if (aspectRatio) {
            player.ratio = aspectRatio;
          }

          // Looping
          if (isLoopingEnabled) {
            player.loop = true;
          }

          // Show Video Controls
          // - video controls get hidden using a css class: '.video-controls-enabled--false'

          // If button exists, hide text and poster
          if ($playButton) {
            $playButton.on('click', function() {

              // Play video
              player.play();
            })
          }

          player.on('statechange', event => {
            //Check if unstarted when state changed and play if so
            if(event.detail.code == '-1') {
              player.play();
            }
          });

          player.on('play', function() {

            // Hide image
            $image.hide();

            // Reset play button icon
            $videoWrapper.removeClass('play-button-icon--visible');

            // Show video
            $videoElement.show();

            // If display text over video unchecked
            if ($videoTextContainer.hasClass('display-text-over-video--false')) {
              $videoTextContainer.hide();
            } else {
              $videoTextContainer.show();
            }

            // Hide play button
            if ($playButton) {
              $playButton.hide();
            }

            // Hide secondary button
            if ($secondaryButton) {
              $secondaryButton.hide();
            }
          })

          // If video is paused, show play button icon
          player.on('pause', function() {
            if ($playButton.is(':hidden') || $playButton.length == 0) {
              $videoWrapper.addClass('play-button-icon--visible');
            }
          })

          // If page loads with video paused and no button showing, show icon
          if (!player.playing && $playButton.is(':hidden') || $playButton.length == 0) {
            $videoWrapper.addClass('play-button-icon--visible');
          }

          return false;
        }
      })
    })
  },
};

/*============================================================================
  Cart
==============================================================================*/
window.cart = {
  init() {
    if ($('#cart_form .tos_agree').length) {
      // Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function () {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          const warning = `<p class="warning animated bounceIn">${Shopify.translation.agree_to_terms_warning}</p>`;
          if ($('p.warning').length === 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }
  },
};

/*============================================================================
  Product
==============================================================================*/
window.selectCallback = function (variant, selector) {
  const evt = document.createEvent('HTMLEvents');
  const $product = $(`.product-${selector.product.id}`);
  const $notifyForm = $(`.notify-form-${selector.product.id}`);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');

  const $notifyFormInputs = $('.notify_form__inputs', $product);
  const notifyEmail = window.Shopify.translation.notify_email;
  const notifyEmailValue = '';
  const notifySend = window.Shopify.translation.notify_email_send;
  const notifyUrl = $notifyFormInputs.data('url');

  // Manually trigger change event so
  // pure JS listeners can receive it
  evt.initEvent('change', false, true);
  selector.variantIdField.dispatchEvent(evt);

  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      window.variantTitle = variant.title.replace(/"/g, '&quot;');
      window.notifyMessage = window.Shopify.translation.notify_message_first + window.variantTitle + window.Shopify.translation.notify_message_last + notifyUrl;
    }
  } else {
    window.notifyMessage = window.Shopify.translation.notify_message_first + window.Shopify.translation.notify_message_last + notifyUrl;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    const notifyCustomerEmail = '';
    window.notifyEmailInput = `<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="${notifyCustomerEmail}" />`;
  } else {
    window.notifyEmailInput = `<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
  window.notifyFormHTML = `${window.notifyEmailInput}<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="${window.notifyMessage}" value="${window.notifyMessage}" /><input class="global-button global-button--primary" type="submit" value="${notifySend}" style="margin-bottom:0px" />`;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.js-product-gallery', $product);
    $sliders.each((_, slider) => {
      const $slider = $(slider);
      const $sliderInstance = window.Flickity.data($slider[0]);
      if ($slider && $sliderInstance !== undefined) {
        const index = $(`[data-image-id="${variant.featured_media.id}"]`).data('index');
        $sliderInstance.select(index, false, true);
      }
    });
  }

  // Toggles images in product slider when inline quickshop and layout set to slider
  if (variant && variant.featured_image && $product.is(':visible')) {
    if (window.Shopify.theme_settings.product_form_style === 'select' && window.Shopify.theme_settings.quick_shop_style === 'inline') {
      const $selectedVariants = $('.products-slider').find('select option:not(.selector-wrapper select option)').filter(':selected');
      $selectedVariants.each(function toggleImage() {
        if ($(this).data('featured-image')) {
          const swatchImage = $(this).data('image');
          const $quickShopElement = $(this).parents('.thumbnail').find('.image__container img');

          $quickShopElement.attr('src', swatchImage);
          $quickShopElement.attr('srcset', swatchImage);
        }
      });
    }
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(v => {
        if (v.id === variant.id) {
          const currentVariant = variant;
          currentVariant.inventory_quantity = v.inventory_quantity;
          currentVariant.inventory_management = v.inventory_management;
          currentVariant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    if (window.Shopify.theme_settings.product_form_style === 'radio') {
      const { length } = variant.options;
      for (let i = 0; i < length; i++) {
        const radioButton = $productForm.find(`.swatch[data-option-index="${escape(i)}"] :radio[value="${variant.options[i].replace(/"/g, '\\"')}"]`);
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    } else {
      $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${window.variantTitle}`);
    }
  }

  if (variant && variant.available === true) {
    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.Shopify.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity === 1) {
          window.itemsLeftText = window.Shopify.translation.one_item_left;
        } else {
          window.itemsLeftText = window.Shopify.translation.items_left_text;
        }

        const inventoryThreshold = parseInt(window.Shopify.theme_settings.inventory_threshold, 10);
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variant.inventory_quantity} ${window.itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (window.Shopify.theme_settings.limit_quantity) {
        if (variant.inventory_policy === 'deny') {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span')
      .text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).removeClass('disabled');
    $('.purchase-details__buttons', $product).removeClass('product-is-unavailable');
    $('.modal_price', $product).removeClass('variant-unavailable');
    $product.find($notifyForm).hide();
    $product.find($notifyFormInputs).empty();
  } else {
    // When product is sold out
    const message = variant ? window.Shopify.theme_settings.sold_out_text : window.Shopify.translation.unavailable_text;

    if (variant) {
      $('.modal_price', $product).removeClass('variant-unavailable');
    } else {
      // Add class to quickshop so we know variant is unavailable
      $('.modal_price', $product).addClass('variant-unavailable');
    }

    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.purchase-details__buttons', $product).addClass('product-is-unavailable');
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span')
      .text(message);
    $('.shopify-payment-button', $product).addClass('disabled');
    $notifyForm.hide();
    $notifyFormInputs.empty();

    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(window.notifyFormHTML);
    }
  }

  if (window.Currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
};

window.productPage = {

  loadQuickshop(url) {
    return window.shopifyAsyncview.load(
      url, // Template name
      { view: 'quickshop' }, // View name (suffix)
    );
  },
  init() {
    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
      },
    ], window.productMedia.setupMedia);

    // Call enable gallery function for product galleries
    $('[data-product-gallery]:not(.product-recommendations [data-product-gallery])').each(function () {
      const $productGallery = $(this);
      window.productPage.enableGallery($productGallery);
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(window.Shopify.translation.notify_success_text);
    }

    if (window.Shopify.theme_settings.product_form_style === 'radio') {
      $('body').on('change', '.swatch :radio', function swatchLogic() {
        const optionIndex = $(this).closest('.swatch').attr('data-option-index');
        const optionValue = $(this).val();
        const parentForm = $(this).closest('.product_form form');
        let notifyForm;

        if (parentForm.siblings('.notify_form').length) {
          window.notifyForm = parentForm.siblings('.notify_form');
        } else {
          window.notifyForm = $('.js-notify-form');
        }

        const option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        const option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        const option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';
        let notifyMessage;

        if (option1 && option2 && option3) {
          window.notifyMessage = `${option1} / ${option2} / ${option3}`;
        } else if (option1 && option2) {
          window.notifyMessage = `${option1} / ${option2}`;
        } else {
          window.notifyMessage = option1;
        }

        window.notifyForm.find('.notify_form_message').attr('value', `${window.notifyForm.find('.notify_form_message').data('body')} - ${window.notifyMessage}`);

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    }

    $('.js-product-gallery a').fancybox({
      width: 800,
      height: 800,
      baseClass: 'product-section__lightbox',
      clickContent: false,
      afterShow(instance) {
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom) {
          $('.fancybox-image').last()
            .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
            .css('display', 'block')
            .parent()
            .zoom({
              touch: false,
              magnify: 1,
            });
        }
      },
      afterClose(instance) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(() => {
          $instanceGallery.fadeIn(100);
          $('.js-product-gallery').find('.is-selected a').focus();
        }, 1);
      },
    });

    /*
    If the product recommendations section exists, run the loadProductRecommendations method
    The selectCallback within this method will only affect the products in the product recommendations section
    */

    if ($('.shopify-section--recommended-products').length) {
      window.productPage.loadProductRecommendations();
    }
  },
  runOptionSelector($element) {
    let $defaultSelector = $('.js-product_section [data-product-form]:not(.product-recommendations .js-product_section [data-product-form])');

    if ($element) {
      $defaultSelector = $element;
    }

    $defaultSelector.each((_, options) => {
      const $options = $(options);
      const $productDetails = $options.closest('.product__details');

      // Set up variables for price ui and surface pickup
      let priceUIEl;

      const paymentTerms = new window.PaymentTerms($productDetails[0]);

      // If smaller screen size and thumbnail hover enabled
      // use price ui element inside of caption instead
      if (window.Shopify.media_queries.medium.matches && window.Shopify.theme_settings.hover_enabled && window.Shopify.theme_settings.quick_shop_enabled && window.Shopify.theme_settings.quick_shop_style === 'inline') {
        priceUIEl = $productDetails.find('.product-info__caption [data-price-ui]')[0];
      } else {
        priceUIEl = $productDetails.find('[data-price-ui]')[0];
      }

      const priceUIBadgeEl = $productDetails.find('[data-price-ui-badge]')[0];
      const surfacePickUpEl = $productDetails.find('[data-surface-pick-up]')[0];
      const JSONData = $options.data('product');
      const isPriceSavingsEnabled = priceUIEl && priceUIEl.closest(['[data-display-savings="true"]']);
      const productTitle = $options.data('product-title');

      let priceUI;
      let priceUIBadge;
      let surfacePickUp;
      let currentVariant;

      if (priceUIEl) {
        priceUI = new window.ShopifyPriceUI.PriceUI(priceUIEl);
      }

      if (priceUIBadgeEl) {
        priceUIBadge = new window.ShopifyPriceUI.PriceUIBadge(priceUIBadgeEl);
      }

      if (surfacePickUpEl) {
        surfacePickUp = new window.ShopifySurfacePickUp(surfacePickUpEl);
        surfacePickUp.onModalRequest(contents => {
          const surfacePickUpModal = document.querySelector('[data-surface-pick-up-modal]');
          let fragment;
          if (currentVariant.title && productTitle) {
            fragment = document.createDocumentFragment();
            const header = document.createElement('div');
            const title = document.createElement('h2');
            header.classList.add('surface-pick-up__modal-header');
            title.classList.add('surface-pick-up__modal-title');
            title.innerHTML = productTitle;
            header.appendChild(title);
            if (currentVariant.title !== 'Default Title') {
              const subtitle = document.createElement('span');
              subtitle.classList.add('surface-pick-up__modal-subtitle');
              subtitle.innerHTML = currentVariant.title;
              header.appendChild(subtitle);
            }
            fragment.appendChild(header);
          }
          surfacePickUpModal.innerHTML = contents;
          surfacePickUpModal.insertBefore(fragment, surfacePickUpModal.firstChild);
          $.fancybox.open(
            surfacePickUpModal,
            {
              hash: false,
              infobar: false,
              toolbar: false,
              loop: true,
              smallBtn: true,
              touch: false,
              video: {
                autoStart: false,
              },
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
              },
            },
          );
        });
      }

      new window.Shopify.OptionSelectors($options.data('select-id'), {
        product: $options.data('product'),
        onVariantSelected: (variant, selector) => {
          currentVariant = variant;

          paymentTerms.update(variant ? variant.id : null);

          if (priceUI) {
            priceUI.load(
              JSONData,
              {
                variant,
                formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
                handler: (priceUIFragment, _product, { variant: v }) => {
                  if (isPriceSavingsEnabled && v) {
                    if (v.compare_at_price > v.price) {
                      const span = document.createElement('span');
                      span.classList.add('sale', 'savings');
                      const savings = v.compare_at_price - v.price;
                      const percentage = Math.round((savings / v.compare_at_price) * 100);
                      span.innerHTML = `${window.Shopify.translation.savings_text} ${percentage}% (<span class="money">${window.Shopify.formatMoney(v.compare_at_price - v.price, $('body').data('money-format'))}</span>)`;

                      priceUIFragment.appendChild(span);
                    }
                  }

                  if (v && v.available) {
                    if (v.price === 0) {
                      const fragment = document.createDocumentFragment();
                      const span = document.createElement('span');
                      span.classList.add('free-price-text');

                      if (window.Shopify.theme_settings.free_text !== '') {
                        span.innerHTML = window.Shopify.theme_settings.free_text;
                      } else {
                        span.innerHTML = `<span class="money">${window.Shopify.formatMoney(v.price, $('body').data('money-format'))}</span>`;
                      }

                      fragment.appendChild(span);

                      return fragment;
                    }

                    return priceUIFragment;
                  }

                  if (!window.Shopify.theme_settings.display_sold_out_price) {
                    const fragment = document.createDocumentFragment();
                    const soldOutText = document.createElement('span');
                    soldOutText.classList.add('sold_out');
                    soldOutText.innerHTML = v
                      ? window.Shopify.translation.sold_out_text
                      : window.Shopify.translation.unavailable_text;
                    fragment.appendChild(soldOutText);
                    return fragment;
                  }

                  // Displays sold out text beside price
                  if (window.Shopify.theme_settings.display_sold_out_price) {
                    const span = document.createElement('span');

                    span.classList.add('sold_out');
                    span.innerHTML = v
                      ? window.Shopify.translation.sold_out_text
                      : window.Shopify.translation.unavailable_text;

                    priceUIFragment.appendChild(span);
                  }

                  return priceUIFragment;
                },
              },
            );

            if (window.Shopify.theme_settings.display_sold_out_price && variant && variant.price === 0 && !variant.available) {
              const priceElement = priceUIEl.querySelector('[data-price]');
              if (!priceElement) { return; }
              if (window.Shopify.theme_settings.free_text !== '') {
                const span = document.createElement('span');
                span.classList.add('free-price-text');
                span.innerHTML = window.Shopify.theme_settings.free_text;
                priceElement.innerHTML = '';
                priceElement.appendChild(span);
              } else if (window.Shopify.theme_settings.free_text === '') {
                priceElement.classList.add('price--sale');
                return;
              }
            }
          }

          if (priceUIBadge) {
            priceUIBadge.load(
              JSONData,
              {
                variant,
                style: 'default',
                formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
                handler: (priceUIFragment, _product, { variant: v }) => {
                  if (v && v.available) {
                    if (!v.compare_at_price || v.compare_at_price <= v.price) {
                      return document.createDocumentFragment();
                    }

                    return priceUIFragment;
                  }

                  if ((v && !v.available) || !v) {
                    const fragment = document.createDocumentFragment();
                    let text;
                    const sticker = document.createElement('div');
                    sticker.classList.add('price-ui-badge__sticker');
                    const stickerText = document.createElement('span');
                    stickerText.classList.add('price-ui-badge__sticker-text');
                    stickerText.setAttribute('data-badge', '');

                    if (v && !v.available) {
                      text = window.Shopify.translation.sold_out_text;
                    }

                    if (!v) {
                      text = window.Shopify.translation.unavailable_text;
                    }

                    stickerText.innerHTML = text;
                    sticker.appendChild(stickerText);
                    fragment.appendChild(sticker);
                    return fragment;
                  }

                  return priceUIFragment;
                },
              },
            );
          }

          // Avoid loading surface pickup for the inline quick shop
          if (surfacePickUp && !$options.closest('.js-product_section').hasClass('inline-quickshop')) {
            surfacePickUp.load(variant ? variant.id : null);
          }

          window.selectCallback(variant, selector);
        },
        enableHistoryState: $options.data('enable-state'),
      });
    });
  },
  enableGallery(selector) {
    // Variables
    const $productGallery = $(selector);
    const $slides = $productGallery.find('.gallery-cell');
    const $thumbnailProductGallery = $productGallery.closest('.js-product_section').find('.product_gallery_nav');
    const $thumbnails = $thumbnailProductGallery.find('.gallery-cell');
    const zoom = $productGallery.data('zoom');
    const productLightbox = $productGallery.data('product-lightbox');
    const thumbnailsEnabled = $productGallery.data('thumbnails-enabled');
    const thumbnailsSliderEnabled = $productGallery.data('thumbnails-slider-enabled');
    const thumbnailsPosition = $productGallery.data('thumbnails-position');
    const thumbnailsArrows = $productGallery.data('gallery-arrows-enabled');
    const slideshowSpeed = $productGallery.data('slideshow-speed');

    // If zoom enabled
    if (zoom === true) {
      if (window.is_touch_device() && window.Shopify.media_queries.medium.matches) {
        // Lightbox has a built-in zoom feature, so check if lightbox is disabled
        if (productLightbox === 'false') {
          document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
        }
      } else {
        document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
      }
    }

    $productGallery.on('ready.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        let videoID;

        switch (mediaType) {
          case 'external_video':

            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false,
                    };
                  }
                }
              });
            }
            break;
          case 'video':

            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false,
                    };
                  }
                }
              });
            }
            break;
          case 'model':
            if ($(slide).hasClass('is-selected')) { // When active slide
              if (mediaType === 'model' && window.isScreenSizeLarge()) {
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }
            }
            break;
          default:
            break;
        }
      });

      // Video looping
      const loopingEnabled = $productGallery.data('video-loop');

      $.each(window.videoPlayers, (index, player) => {
        const videoPlayer = player;
        videoPlayer.loop = loopingEnabled;
      });
    });

    $productGallery.on('change.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type of current slide
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) { // When active slide
          switch (mediaType) {
            case 'model':

              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */

              if (window.isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });

                // On mouseleave event, bind flickity
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }

              // Listen for model pause/play events
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', () => {
                $productGallery.flickity('unbindDrag');
              });

              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', () => {
                $productGallery.flickity('bindDrag');
              });
              break;
            default:
              $productGallery.flickity('bindDrag');
              break;
          }
        } else {
          // When inactive slide
          switch (mediaType) {
            case 'external_video':
              // Youtube video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            case 'video':
              // HTML5 video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            default: break;
          }
        }
      });

      // Restore 3d model icons
      window.productMedia.showModelIcon($productGallery);
    });

    $productGallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1,
      autoPlay: slideshowSpeed * 1000,
      watchCSS: false,
    });

    // Adjust arrows height if controls are hidden/shown
    $.each(window.videoPlayers, (index, player) => {
      // When controls are hidden, height should be auto
      player.on('controlshidden', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'auto');
      });
      // When controls are shown, height should account for controls bar
      player.on('controlsshown', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'calc(100% - 64px)');
      });
    });

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (parseInt(player.media.dataset.plyrVideoId, 10) === videoID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id === iframeID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function checkForVideos() {
      $slides.each((index, slide) => {
        // Variables
        const $slide = $(slide);
        const mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        let videoID = $slide.find('video').data('plyr-video-id');
        const $iframeVideo = $slide.find('iframe');
        const iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType === 'video') {
            videoID = $slide.find('video').data('plyr-video-id');
            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType === 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile
    const $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
      $sliderArrows.on('click', () => {
        const pId = $productGallery.data('product-id');

        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });

        return false;
      });

      $thumbnails.on('click', event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        $productGallery.flickity('select', index);

        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, (_index, model) => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, (_index, model) => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });
        return false;
      });

      $thumbnails.keypress(event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        if (event.which === 13) {
          $productGallery.flickity('select', index);

          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');

          $productGallery.on('settle.flickity', () => {
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $productGallery.off('settle.flickity');
          });

          // Find out media type of featured media slide
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          return false;
        }
        return undefined;
      });
    }

    // Thumbnail gallery logic begins
    if (thumbnailsEnabled === true && thumbnailsSliderEnabled === true && $slides.length > 1) {
      // If desktop determine which slider we build
      if (window.Shopify.media_queries.large.matches) {
        // If thumbnail position is left/right then vertical slider gets enabled
        if (thumbnailsPosition === 'left' || thumbnailsPosition === 'right') {
          $thumbnailProductGallery.css('max-height', $productGallery.closest('.product-gallery').outerHeight());
          $thumbnailProductGallery.addClass('vertical-slider-enabled');

          $thumbnails.on('click', event => {
            const index = $(event.currentTarget).index();
            $productGallery.flickity('select', index);
          });

          const navCellHeight = $thumbnails.height();
          const navHeight = $thumbnailProductGallery.height();

          $productGallery.on('select.flickity', () => {
            // set selected nav cell
            const flkty = $productGallery.data('flickity');
            $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');
            const $selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected');

            // scroll nav
            const scrollY = $selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
            $thumbnailProductGallery.animate({
              scrollTop: scrollY,
            });
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $thumbnails.length > 5 ? thumbnailsArrows : false,
            asNavFor: $productGallery[0],
          });

          $thumbnailProductGallery.on('settle.flickity', () => {
            $thumbnailProductGallery.flickity('resize');
          });

          $(window).on('load', () => {
            $thumbnailProductGallery.flickity('resize');
          });

          // Once thumbnail is focused, move carousel to that cell
          $.each($thumbnails, (index, thumbnail) => {
            const $thumbnail = $(thumbnail);
            if ($thumbnail.hasClass('is-selected')) {
              $thumbnail.on('focus', () => {
                $thumbnailProductGallery.flickity('selectCell', index);
              });
            }
          });
        }
      } else {
        // If not on desktop, create standard thumbnail slider
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? thumbnailsArrows : false,
          asNavFor: $productGallery[0],
        });
      }
    } else if (thumbnailsEnabled === true) {
      // If thumbnail slider is disabled, ensure thumbnails can still navigate product images
      $thumbnailProductGallery.find('.product-gallery__thumbnail').on('click', function () {
        const index = $(this).index();
        $productGallery.flickity('selectCell', index);
      });
    }

    $(window).on('load', () => {
      $productGallery.flickity().flickity('resize');
    });

    $productGallery.on('settle.flickity', () => {
      $productGallery.flickity().flickity('resize');
    });
  },
  loadProductRecommendations() {
    const $productRecommendations = $('.product-recommendations');
    const $productRecommendationsSection = $('.shopify-section--recommended-products');
    const $productRecommendationsContainer = $('[data-product-recommendations-container]');
    const $productRecommendationsDetailsBlock = $('.product-recommendations--details-block');
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');
    const recommendationsURL = $productRecommendations.data('recommendations-url');
    const sectionEnabled = $productRecommendationsSection.find($productRecommendations).data('enabled');
    const $recommendedProductSlider = $('.js-recommended-products-slider');

    function loadDynamicProducts() {
      // Build request URL
      const requestUrl = `${recommendationsURL}?section_id=product-recommendations&limit=${limit}&product_id=${productID}`;

      // Make ajax call to request information for window.Shopify's recommended products
      $.ajax({
        type: 'GET',
        url: requestUrl,
        success(data) {
          if (!sectionEnabled) {
            return;
          }

          const $recommendedProductsElement = $(data).find('.product-recommendations').html();

          // Insert product list into the product recommendations container
          $productRecommendationsContainer.html($recommendedProductsElement);

          // Hide product recommendations section
          $productRecommendationsSection.hide();

          // Initialize product slider if it exists on page
          if ($recommendedProductSlider.length) {
            window.productPage.recommendedProductsSlider();
          } else {
            // Call enable gallery function for product galleries
            $('[data-product-recommendations-container] [data-product-gallery]').each((_, gallery) => {
              const $productGallery = $(gallery);
              window.productPage.enableGallery($productGallery);
            });
          }

          // Re-link inline quickshop
          if (window.Shopify.theme_settings.quick_shop_style === 'inline') {
            window.productPage.runOptionSelector($('[data-product-recommendations-container] .js-product_section [data-product-form]'));
          }

          // Quickshop initialization
          window.quickShop.init();

          // Initialize product slider if it exists on page
          if ($recommendedProductSlider.length) {
            window.productPage.recommendedProductsSlider();
          }

          // Converting the currencies
          if (window.Currency.show_multiple_currencies) {
            window.currencyConverter.convertCurrencies();
          }

          // Initialize shopify payment buttons
          if (window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          window.videoFeature.setupRecommendedVideoPlayer();

          if (window.Shopify.theme_settings.collection_secondary_image) {
            window.imageFunctions.showSecondaryImage();
          }

          window.hideNoScript();
        },
      });
    }

    if (!sectionEnabled) { return; }

    // If meta collection, no need to run API request
    const metaCollection = $productRecommendations.hasClass('meta-related-recommended-collection');

    if (metaCollection) {
      // Takes care of moving content from Shopify section into block container
      const data = $productRecommendationsSection.find($productRecommendations).html();
      $productRecommendationsContainer.html(data);
      $productRecommendationsSection.hide();
      $productRecommendationsContainer.show();

      // Initialize product slider if it exists on page
      if ($recommendedProductSlider.length) {
        window.productPage.recommendedProductsSlider();
      } else {
        // Call enable gallery function for product galleries
        $('[data-product-recommendations-container] [data-product-gallery]').each(function () {
          const $productGallery = $(this);
          window.productPage.enableGallery($productGallery);
        });
      }

      // Re-link inline quickshop
      if (window.Shopify.theme_settings.quick_shop_style === 'inline') {
        window.productPage.runOptionSelector($('[data-product-recommendations-container] .js-product_section [data-product-form]'));
      }
    } else {
      loadDynamicProducts();
    }
  },
  productSwatches() {
    // Swatches linked with selected options
    if (window.Shopify.theme_settings.product_form_style === 'radio') {
      if ($('.js-product_section').length) {
        const $productForms = $('.js-product_section').find('.product_form');

        $productForms.addClass('is-visible');

        // Loop through each product and set the initial option value state

        $productForms.each((_, productForm) => {
          const $productForm = $(productForm);
          const JSONData = $productForm.data('product');
          const productID = $productForm.data('product-id');
          const productSection = `.product-${productID} .js-product_section`;
          const swatchOptions = $productForm.find('.swatch_options .swatch');
          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      // Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('.js-product_section').length > 1) {
        $('body').on('click', '.swatch-element', swatchElement => {
          const $swatchElement = $(swatchElement.currentTarget);
          const swatchValue = $swatchElement.data('value').toString();

          $swatchElement
            .siblings(`input[value="${swatchValue.replace(/"/g, '\\"')}"]`)
            .prop('checked', true)
            .trigger('change');

          const JSONData = $swatchElement.parents('.product_form').data('product');
          const productID = $swatchElement.parents('.product_form').data('product-id');
          const productSection = `.product-${productID} .js-product_section`;
          const swatchOptions = $swatchElement.parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }
    }
  },
  recommendedProductsSlider() {
    $('.js-recommended-products-slider .products-slider').each((_, productSlider) => {
      const $productSlider = $(productSlider);
      const productsPerSlide = $productSlider.data('products-per-slide');
      const productsLimit = $productSlider.data('products-limit');
      const productsAvailable = $productSlider.data('products-available');
      let cellAlign;
      let draggable;
      let prevNext;
      let wrapAround;
      let initialIndex;

      const lessSlidesThanProducts = productsAvailable > productsPerSlide;
      const limitGreaterThanSlide = productsLimit > productsPerSlide;
      const evenSlide = productsPerSlide % 2 === 0;

      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        cellAlign = 'left';
      } else {
        cellAlign = 'center';
      }

      if (lessSlidesThanProducts && limitGreaterThanSlide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        initialIndex = 0;
      } else if (productsPerSlide === '3' && productsAvailable) {
        initialIndex = 1;
      } else if (productsPerSlide === '5' && productsAvailable) {
        initialIndex = 2;
      } else if (productsPerSlide === '7' && productsAvailable) {
        initialIndex = 3;
      }

      if (window.Shopify.media_queries.medium.matches) {
        cellAlign = 'center';
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $productSlider.parents('.even-num-slides').removeClass('even-num-slides');
      }

      $productSlider.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable,
        cellAlign,
        prevNextButtons: prevNext,
        wrapAround,
        contain: true,
        freeScroll: true,
        initialIndex,
      });
    });
  },
  initializeQuantityBox() {
    $('body').on('click', '.js-change-quantity', e => {
      const $this = $(e.currentTarget);
      const $input = $this.siblings('input');
      const val = parseInt($input.val(), 10);
      let valMax = 100000000000000000000000000000;
      const valMin = $input.attr('min') || 0;
      if ($input.attr('max') != null) {
        valMax = $input.attr('max');
      }
      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
      } if (val > valMax) {
        $input.val(valMax);
      }
      if ($this.data('func') === 'plus') {
        if (val < valMax) $input.val(val + 1);
      } else {
        if (val > valMin) $input.val(val - 1);
        if ($this.parents('.cart_item').length) {
          if (val - 1 === 0) {
            $this.closest('.cart_item').addClass('animated fadeOutUp');
          }
        }
      }
      $input.trigger('change');
    });
  },
  unload($target) {
    const $slider = $target.find('.products-slider');
    $slider.flickity('destroy');
    $('body').off('click', '.js-change-quantity');
  },
};

/*============================================================================
  Header
==============================================================================*/

window.header = {
  init() {

    var closeDropdown = function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container').hide();
      $('.mobile_nav').find('div').removeClass('open');
    };

    var closeMiniCart = function() {
      $('body').removeClass('is-active').removeClass('blocked-scroll');
      $('.dropdown_link').toggleClass('active_link');
      $('.cart-container').removeClass('active_link');
    };

    var openMiniCart = function($cart_container) {
      $('body').addClass('blocked-scroll');
      $('.mobile_nav div').removeClass('open');
      $('.dropdown_link').removeClass('active_link');
      $cart_container.addClass('active_link');
    };

    var closeAllSubSubmenus = function() {
      $('.vertical-menu_sub-submenu').removeClass('is-visible');
      $('.vertical-menu_sub-submenu').prev('a').attr('data-click-count', 0);
    }

    var closeAllSubmenus = function() {
      $('.vertical-menu_submenu').removeClass('is-visible');
      $('.vertical-menu_submenu').prev('a').attr('data-click-count', 0);
      $('.mega-menu-parent').attr('data-click-count', 0);
      closeAllSubSubmenus();
    }

    // Store link items with data attribute of 'data-show-dropdown-on-click' in a variable
    var $openDropdownOnClick = $('.main-nav__wrapper').find('[data-show-dropdown-on-click]');

    //Vertical menu enabled
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical, .mega-menu-parent').attr('data-click-count', 0);

      if ($openDropdownOnClick.length == 0) {
        $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
          var $dropdown = $(this).parents('.main-nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');

          $('.dropdown_container').hide();
          $('.active_link').removeClass('active_link');
          if(!$(this).hasClass('active_link')) {
            $('.dropdown_container').hide();
            $(this).children('a').addClass('active_link');
            $('.is-absolute').parent().addClass('feature_image');
          }
        });
      }

      //Enable touch on parent link if user is on a touch device and desktop menu is visible, OR if 'open dropdown on click' setting is enabled
      if (window.is_touch_device() || $openDropdownOnClick.length >= 1){
        $('body').on('touchstart click', '.vertical-menu .sublink a, .vertical-menu_submenu .sublink a', function(e) {

          var clicked;
          var verticalMenu = $(this);
          var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
          var $dropdownVerticalSubMenu = $(verticalMenu).next('.vertical-menu_sub-submenu');

          var showMenu = function() {
            $dropdownVertical.removeClass('hidden');
            $dropdownVerticalSubMenu.removeClass('hidden');
            $dropdownVertical.addClass('is-visible');
            $dropdownVerticalSubMenu.addClass('is-visible')
          }

          if(e.type == "touchstart") {
            clicked = true;
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu, e.target);
              e.preventDefault();
              e.stopPropagation();
            }
          }
          else if(e.type == "click" && !clicked) {
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu, e.target);
              e.preventDefault();
              e.stopPropagation();
            }
          }
          else {
            clicked = false;
          }

          function openDropdown(verticalMenu, target) {

            var $dropdownMegaMenu = $(verticalMenu).parents('.main-nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');

            var clickCount = $(verticalMenu).attr('data-click-count');

            $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
            $('.mega-menu-parent').attr('data-click-count', 0);
            $('.dropdown_link--vertical').attr('data-no-instant', true);
            $('.dropdown_container').hide();

            $dropdownMegaMenu.show();
            // Conditional to not close the parent dropdown when selecting various sub menus in the same parent
            if ($(target).parents('.vertical-menu_submenu').hasClass('is-visible')) {
              closeAllSubSubmenus();
              $('.is-absolute').parent().addClass('feature_image');
            } else {
              closeAllSubmenus();
              $('.is-absolute').parent().addClass('feature_image');
            }

            showMenu();

            //capture touch event or click event
            clickCount++;
            $(verticalMenu).attr('data-click-count', clickCount);

            if (clickCount < 2){
              e.preventDefault();
              e.stopPropagation();
              return false;
            }

          }
          // Close dropdown if click anywhere outside dropdown menu
          $('html').on('click', function(event) {
            if (!$(event.target).closest('.dropdown_container').length && !$(event.target).hasClass('url-deadlink')) {
              closeAllSubmenus();
              $('.is-absolute').parent().addClass('feature_image');
            }
          });
        });
      }
    }

    if ($('.promo-banner').length) {
      const promoBanner = window.Cookies.get('promo-banner');

      if (promoBanner !== 'dismiss') {
        $('body').addClass('promo-banner--show');
        $('.promo-banner').on('click', '.promo-banner__close', () => {
          $('body').removeClass('promo-banner--show');
          window.Cookies.set('promo-banner', 'dismiss', {
            expires: 30, path: '', domain: '', sameSite: 'None', secure: true,
          });
        });
      }
    }

    //offscreen check for menu
    $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
      if($(this).is(':off-right')) {
        $(this).addClass('vertical-menu--align-right');
      }
    });

    //Click anywhere outside of dropdown to close
    $('html').on('click', function(event) {
      if (!$(event.target).closest('.cart-container').length && $('.cart_content').is(':visible')) {

        closeMiniCart();
      }

      if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible') && !$(event.target).hasClass('url-deadlink') && !$(event.target).hasClass('mega-menu-parent')) {
        $('.is-absolute').parent().addClass('feature_image');
        $('body').removeClass('is-active');
        closeDropdown();
        if ($openDropdownOnClick.length) {
          $('.dropdown_link').attr('data-click-count', 0);
        }
      }

    });

    //Only apply on larger screen sizes
    if (Shopify.media_queries.large.matches) {
      if ($('.header').hasClass('header-fixed--true')){

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('.main-nav__wrapper.sticky_nav').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });

        if (!$('.main-nav__wrapper').hasClass('sticky_nav')) {
          var sticky_nav = new Headhesive('.main-nav__wrapper', {
            offset: 700,
            throttle: 300,
            classes: {
              clone: 'sticky_nav',
              stick: 'sticky_nav--stick',
              unstick: 'sticky_nav--unstick'
            },
            onInit: function() {
              $('.sticky_nav .secondary_logo').css('display', 'none');
              $('.sticky_nav .primary_logo').css('display', 'block');
              $('.sticky_nav .icon-search').css('display', 'block');
              $('.sticky_nav .search__form').css('display', 'none');
              $('.sticky_nav .search-link').css('display', 'block');
              $('.sticky_nav .main-nav').append($(".header .cart-container").clone());
            },
            onStick: function() {
              var maxHeight = 0;
              var $targetHeightElement = $('.sticky_nav .main-nav');

              $targetHeightElement.each(function() {
                maxHeight = maxHeight > $(this).outerHeight() ? maxHeight : $(this).outerHeight();
              });

              $('.sticky_nav .mini_cart').css('height', maxHeight);
              $('.sticky_nav .cart_content').css('top', maxHeight);
            },
            onUnstick: function() {
              $('.cart-container').removeClass('active_link');
            }
          });
        }
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main-nav__wrapper').length > 1) {
          $('.main-nav__wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    //Mobile menu
    } else {
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('#header').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }
    }

    // Avoid cart_content duplicating for mobile screen sizes
    if ($('#header .cart_content').length < 1) {
      $('#header .cart-container').append($('.header .cart_content').clone());
    }

    if (window.is_touch_device() && Shopify.media_queries.medium.matches || Shopify.media_queries.medium.matches) {
      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link, .vertical--dropdown', function (e) {
        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          window.$dropdown = $(this).parents('#header').find(`[data-dropdown="${$(this).data('dropdown-rel')}"]`);

          if (!$(this).hasClass('mini_cart')) {
            $('.cart-container').removeClass('active_link');
          }
        } else {
          if ($(this).hasClass('icon-search')) {
            window.location = $(this).attr('href');
            return false;
          }

          window.$dropdown = $(this).parents('.main-nav').find(`[data-dropdown="${$(this).data('dropdown-rel')}"]`);
        }

        if (window.$dropdown.is(':visible') || window.$dropdown.attr('class') === undefined) {
          window.$dropdown.hide();
          $('body').removeClass('is-active');
        } else {
          $('.dropdown_container').hide();
          if (!$(this).hasClass('cart-container')) {
            $('.is-absolute').parent().removeClass('feature_image');
          }
          window.$dropdown.show();
          $('body').addClass('is-active');
        }

        if (window.$dropdown.is(':visible')) {
          e.stopPropagation();
          return false;
        }
      });

      $('body').on('click', '.mobile_nav', function () {
        $(this).find('div').toggleClass('open');
      });

      // Toggle mini-cart with menu icon
      if (Shopify.theme_settings.cart_action !== 'redirect_cart') {
        $('.mini_cart').on('click', function (e) {
          const $cartContainer = $(this).parent();
          if ($cartContainer.hasClass('active_link')) {
            closeMiniCart();
            $('body').removeClass('blocked-scroll');
          } else {
            openMiniCart($cartContainer);
            $('body').addClass('blocked-scroll');
          }
          if (window.is_touch_device() || Shopify.media_queries.medium.matches) {
            e.preventDefault();
          }
        });
      }

      $('.cart_content__continue-shopping').on('click', () => {
        closeMiniCart();
      });
    } else {
      // Enable touch on parent link if on touch device and desktop menu is visible
      if ($openDropdownOnClick.length || window.is_touch_device()) {
        $('.dropdown_link').attr('data-click-count', 0);

        $('.dropdown_link').on('click', function (e) {
          const $dropdown = $(this).parents('.main-nav').find(`[data-dropdown="${$(this).data('dropdown-rel')}"]`);

          let clickCount = $(this).attr('data-click-count');
          closeAllSubmenus();
          closeDropdown();

          $('.dropdown_link').not(this).attr('data-click-count', 0);
          $('.dropdown_link').attr('data-no-instant', true);

          $('.active_link').removeClass('active_link');

          if (!$(this).hasClass('active_link')) {
            $dropdown.show();

            if ($(this).hasClass('mini_cart')) {
              if (!$('body').hasClass('cart')) {
                $(this).parent('.cart-container').addClass('active_link');
              }
            } else {
              $(this).addClass('active_link');
              $('.is-absolute').parent().removeClass('feature_image');
            }
          }

          // Capture touch event
          if (e.type === 'click') {
            clickCount++;
            $(this).attr('data-click-count', clickCount);

            if (clickCount < 2) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        });
      }

      if ($openDropdownOnClick.length === 0) {
        $('.nav a, .logo a').not('.cart_content a').on('mouseenter', function () {
          if (!$(this).hasClass('active_link')) {
            $('.dropdown_container').hide();
            $('.active_link').removeClass('active_link');
            $('.is-absolute').parent().addClass('feature_image');
          }
        });

        $('.main-nav, .top-bar, .cart-container').on('mouseleave', () => {
          $('.dropdown_container').hide();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
          $('body').removeClass('is-active');
        });

        $('.dropdown_link').on('mouseover', function () {
          $('.dropdown_container').hide();

          const $dropdown = $(this).parents('.main-nav').find(`[data-dropdown="${$(this).data('dropdown-rel')}"]`);

          $('.active_link').removeClass('active_link');

          if (!$(this).hasClass('active_link')) {
            $dropdown.show();

            if ($(this).hasClass('mini_cart')) {
              if (!$('body').hasClass('cart')) {
                $(this).parent('.cart-container').addClass('active_link');
              }
            } else {
              $(this).addClass('active_link');
              $('.is-absolute').parent().removeClass('feature_image');
            }
          }
        });
      }
    }
  },
  removeDataAttributes(target) {
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },
  loadMegaMenu() {

    //Remove old mega-menus so that theme-editor works properly
    $('.sticky_nav .mega-menu').remove();
    $('.header .mega-menu').remove();

    //Clone the mega menu from section into sticky_nav
    $('.mega-menu-container .mega-menu')
      .clone()
      .appendTo('.sticky_nav .main-nav');
    //Remove theme-editor data-attributes
    header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

    //Loop through mega-menus to add arrow to parent
    $('.mega-menu-container .mega-menu').each(function(index){
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link')
        .removeClass('top_link');

      $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo('.header .main-nav');
    });

    //Remove default mega menus if vertical menus are selected
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
      $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
        var megaMenuValue = $(this).data('dropdown-rel');
        $('[data-dropdown="' + megaMenuValue + '"]').remove();
      })
    }
    var $openDropdownOnClick = $('.main-nav__wrapper').find('[data-show-dropdown-on-click]');

    if ($openDropdownOnClick.length) {
      $('.mega-menu-parent').on('click', function(e) {

        if(!$(this).hasClass('active_link')) {
          $('.dropdown_container').hide();
          $(this).parents('.main-nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

          $(this).addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');
        }
      });
    }

    //Remove theme-editor data-attributes
    header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    if (window.is_touch_device() || Shopify.media_queries.medium.matches) {
      $('.dropdown_link').attr('data-no-instant', true);
    }

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu() {

    //Loop through mega menus and add to mobile menu
    $('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
    });
  },
  unloadMegaMenu() {
    $('.header .mega-menu').remove();
    $('.mega-menu-container .mega-menu').each(function(index){
      var menuParent = $(this).data('dropdown');
      $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload() {
    $('body').off('click', '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
    $('.cart_content__continue-shopping').off('click');
    $('body').off('click', '.banner a[href^="#"]');
    $('.main-nav__wrapper.sticky_nav').remove();
  }
}

/*============================================================================
  Map
==============================================================================*/
window.map = {
  init() {
    if ($('.lazymap').length > 0) {
      lazyframe('.lazymap');
    }

    if ($('.maps').hasClass('js-api-map')) {
      const mapsToLoad = [];
      // Create map settings array
      $('.map').each(function (i) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, i => {
        // Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });
        // Load maps script and find location coordinates
        $.getScript(
          `https://maps.googleapis.com/maps/api/js?key=${mapsToLoad[i].apikey}`,
        ).then(() => {
          window.map.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },
  findLocation(mapArray) {
    let geoLat;
    let geoLng;
    const geocoder = new google.maps.Geocoder();
    // Find and set coordinates
    geocoder.geocode({ address: mapArray.dataset.address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();
        // Create map
        window.map.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log(`Error:${status}`);
      }
    });
  },
  initMap(lat, lng, mapArray) {
    const location = { lat, lng };
    let styleJson = [];
    // Set style JSON
    if (mapArray.mapstyle === 'aubergine') {
      styleJson = [{ elementType: 'geometry', stylers: [{ color: '#1d2c4d' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#8ec3b9' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#1a3646' }] }, { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#4b6878' }] }, { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#64779e' }] }, { featureType: 'administrative.province', elementType: 'geometry.stroke', stylers: [{ color: '#4b6878' }] }, { featureType: 'landscape.man_made', elementType: 'geometry.stroke', stylers: [{ color: '#334e87' }] }, { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#023e58' }] }, { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#283d6a' }] }, { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#6f9ba5' }] }, { featureType: 'poi', elementType: 'labels.text.stroke', stylers: [{ color: '#1d2c4d' }] }, { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#023e58' }] }, { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#3C7680' }] }, { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#304a7d' }] }, { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#98a5be' }] }, { featureType: 'road', elementType: 'labels.text.stroke', stylers: [{ color: '#1d2c4d' }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#2c6675' }] }, { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#255763' }] }, { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#b0d5ce' }] }, { featureType: 'road.highway', elementType: 'labels.text.stroke', stylers: [{ color: '#023e58' }] }, { featureType: 'transit', elementType: 'labels.text.fill', stylers: [{ color: '#98a5be' }] }, { featureType: 'transit', elementType: 'labels.text.stroke', stylers: [{ color: '#1d2c4d' }] }, { featureType: 'transit.line', elementType: 'geometry.fill', stylers: [{ color: '#283d6a' }] }, { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#3a4762' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0e1626' }] }, { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#4e6d70' }] }];
    } else if (mapArray.mapstyle === 'retro') {
      styleJson = [{ elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] }, { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c9b2a6' }] }, { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#dcd2be' }] }, { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#ae9e90' }] }, { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] }, { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] }, { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#93817c' }] }, { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#a5b076' }] }, { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#447530' }] }, { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#f5f1e6' }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#fdfcf8' }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#f8c967' }] }, { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#e9bc62' }] }, { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#e98d58' }] }, { featureType: 'road.highway.controlled_access', elementType: 'geometry.stroke', stylers: [{ color: '#db8555' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#806b63' }] }, { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] }, { featureType: 'transit.line', elementType: 'labels.text.fill', stylers: [{ color: '#8f7d77' }] }, { featureType: 'transit.line', elementType: 'labels.text.stroke', stylers: [{ color: '#ebe3cd' }] }, { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] }, { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#b9d3c2' }] }, { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#92998d' }] }];
    } else if (mapArray.mapstyle === 'silver') {
      styleJson = [{ elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] }, { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] }, { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] }, { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] }, { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] }, { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }, { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] }, { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] }, { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }, { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] }, { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] }, { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }];
    } else if (mapArray.mapstyle === 'night') {
      styleJson = [{ elementType: 'geometry', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] }, { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#d59563' }] }, { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#d59563' }] }, { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#263c3f' }] }, { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#6b9a76' }] }, { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#38414e' }] }, { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#212a37' }] }, { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9ca5b3' }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#746855' }] }, { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#1f2835' }] }, { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#f3d19c' }] }, { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#2f3948' }] }, { featureType: 'transit.station', elementType: 'labels.text.fill', stylers: [{ color: '#d59563' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#17263c' }] }, { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#515c6d' }] }, { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#17263c' }] }];
    } else { styleJson = []; }
    // Create google maps link
    $('.js-map-link').attr(
      'href',
      `https://www.google.com/maps/place/${
        mapArray.directions
      }/@${
        lat
      },${
        lng}`,
    );
    // Set map options
    const mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false,
    };
    // Create map
    const map = new google.maps.Map(
      document.getElementById(mapArray.sectionid),
      mapOptions,
    );
    // Show pin
    if (mapArray.showpin === true) {
      const marker = new google.maps.Marker({
        position: location,
        map,
      });
    }
  }
}

/*============================================================================
  Global accordions
==============================================================================*/
window.accordion = {
  init() {
    let flg = 0;
    const $faqHeading = $('.faqAccordion > dt > button, .accordion > dt > a');
    $('.faqAccordion > dd, .accordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.on('click activate', function () {
      if (flg) return false;
      flg = 1;
      const state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(() => {
        flg = 0;
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  }
}

/*============================================================================
  Global shortcodes
==============================================================================*/
class ProductCTA extends HTMLElement {
  static get shortcode() {
    return 'product-cta';
  }

  constructor() {
    // Always call super first in constructor
    super();

    // Create a shadow root
    this.attachShadow({ mode: 'open' }); // sets and returns 'this.shadowRoot'
    this.events = [];

    const forAttr = this.getAttribute('for');
    const variants = forAttr ? document.querySelector(`#${forAttr} [data-variants]`) : null;
    const variantId = this.getAttribute('variantid');
    const appendto = document.querySelector(this.getAttribute('appendto'));

    if (!variants || !variantId) {
      this._setVisible(false);
      return;
    }

    if (appendto) {
      appendto.appendChild(this);
    }

    // Remove element from DOM and insert new element into position
    this._registerEvent({ el: variants, event: 'change', listener: e => this._onVariantChange(e, variantId) });
    this._setVisible(variants.value === this.variantId);
  }

  connectedCallback() {
    const href = this.getAttribute('href') || '#';
    const target = this.getAttribute('target');
    const style = document.createElement('style');
    const a = document.createElement('a');
    const slot = document.createElement('slot');

    style.innerHTML = `
      a {
        color: inherit;
        cursor; inherit;
        text-decoration: inherit;
      }
    `;

    a.href = href;
    a.target = target;
    a.appendChild(slot);

    if (target === '_blank') {
      const icon = document.createElement('span');
      icon.classList.add('button-icon');
      icon.setAttribute('aria-label', '(New window)');
      icon.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.81792 2.29812L5.68732 5.42884L6.57121 6.3127L9.70198 3.18183L9.70227 5.51933L10.9523 5.51917L10.9518 1.67302L10.9517 1.0481L10.3268 1.0481L6.48062 1.04815L6.48064 2.29815L8.81792 2.29812ZM1.67297 1.04817H1.04797V1.67317V10.327V10.952H1.67297H10.3268H10.9518V10.327V8.13026H9.70175V9.70195H2.29797V2.29817H3.83642V1.04817H1.67297Z" fill="currentColor"/></svg>';

      // attach the created elements to the shadow DOM
      a.appendChild(icon);
    }

    this.shadowRoot.append(style, a);
  }

  disconnectedCallback() {
    this.events.forEach(({ el, event, listener }) => el.removeEventListener(event, listener));
    this.shadowRoot.innerHTML = '';
    this._setVisible(true);
  }

  _registerEvent({ el, event, listener }) {
    this.events.push({ el, event, listener });

    el.addEventListener(event, listener);

    return { el, event, listener };
  }

  _setVisible(visible) {
    this.toggleAttribute('hidden', !visible);
  }

  _onVariantChange(e, variantId) {
    this._setVisible(e.currentTarget.value === variantId);
  }
}

customElements.define(ProductCTA.shortcode, ProductCTA);


$('#contact-whatsapp-submit').on('click', function() {
    var WhatsappMessage = '';
    var ContactWhatsapp = $(this).data('contact-whatsapp');
    var blockID = $(this).data('contact-form-id');
    $(this).parents('form').each(function() {
        var forminputs = $(this).find(':input:visible');
        forminputs.each(function() {
            WhatsappMessage += $(this).attr('placeholder').replace(/\*/g,'') + ': ' + $(this).val() + '\n';
        })
    });
    var encodedWhatsapp = encodeURI(WhatsappMessage);
    var whatsappURL = `https://wa.me/${ContactWhatsapp}?text=${encodedWhatsapp}`
    window.open(whatsappURL, "", "_blank");
})
     
